<template>
  <div class="headerContent">
    <span class="mainPageTitle" style="cursor: pointer" @click="handleCancel">
      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 46 46" fill="none">
        <path d="M10.0625 21.5625H38.8125C39.1937 21.5625 39.5594 21.714 39.829 21.9835C40.0986 22.2531 40.25 22.6188 40.25 23C40.25 23.3812 40.0986 23.7469 39.829 24.0165C39.5594 24.2861 39.1937 24.4375 38.8125 24.4375H10.0625C9.68125 24.4375 9.31562 24.2861 9.04603 24.0165C8.77645 23.7469 8.625 23.3812 8.625 23C8.625 22.6188 8.77645 22.2531 9.04603 21.9835C9.31562 21.714 9.68125 21.5625 10.0625 21.5625Z" fill="var(--primary-color)" />
        <path d="M10.6576 22.9999L22.5803 34.9196C22.8502 35.1895 23.0018 35.5556 23.0018 35.9374C23.0018 36.3191 22.8502 36.6852 22.5803 36.9551C22.3103 37.225 21.9442 37.3767 21.5625 37.3767C21.1808 37.3767 20.8147 37.225 20.5448 36.9551L7.60726 24.0176C7.47339 23.8841 7.36718 23.7255 7.29471 23.5508C7.22224 23.3762 7.18494 23.1889 7.18494 22.9999C7.18494 22.8108 7.22224 22.6236 7.29471 22.4489C7.36718 22.2743 7.47339 22.1156 7.60726 21.9821L20.5448 9.04461C20.8147 8.77469 21.1808 8.62305 21.5625 8.62305C21.9442 8.62305 22.3103 8.77469 22.5803 9.04461C22.8502 9.31454 23.0018 9.68063 23.0018 10.0624C23.0018 10.4441 22.8502 10.8102 22.5803 11.0801L10.6576 22.9999Z" fill="var(--primary-color)" />
      </svg>
      <span style="margin-left: 10px"> {{ isManual ? $t('view_document.title.manual_validation') : $t('view_document.title.view_job') }}</span></span
    >
    <span class="headerRightText"> {{ $t('view_document.header.job_id') }} :{{ this.$route.query.jobId }} </span>
    <div class="headerStatus">
      <div class="statusItem">
        <div class="statusIcon">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
          </svg>
        </div>
        <span class="statusLabel">{{ $t('view_document.header.processing_status') }}</span>
        <span class="statusValue">{{ this.mainResponse?.result_document?.filter((d) => d.status === 'completed')?.length }}/{{ this.mainResponse?.result_document?.length }}</span>
      </div>
      <div class="statusItem" style="max-width: 300px">
        <div class="statusIcon">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
            <path d="M3 3v5h5" />
            <path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16" />
            <path d="M16 21h5v-5" />
          </svg>
        </div>
        <span class="statusLabel">{{ $t('view_document.header.vasion_integration_status') }}</span>
        <span class="statusValue">{{ this.mainResponse?.result_document?.filter((d) => d?.vasion_status === 'completed')?.length }}/{{ this.mainResponse?.result_document?.length }}</span>
      </div>
      <div class="statusItem" style="max-width: 300px">
        <div class="statusIcon">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M9 11l3 3L22 4" />
            <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
          </svg>
        </div>
        <span class="statusLabel">{{ $t('view_document.header.user_selected_classification') }}</span>
        <span class="statusValue">{{ this.mainResponse?.job?.is_user_selected_classification === true ? $t('view_document.header.yes') : $t('view_document.header.no') }}</span>
      </div>
    </div>
    <div class="headerDocumentDropdown">
      <select style="height: 38px; cursor: pointer; width: 580px !important" v-model="selectedDocumentGroupIndex" @change="handleHeaderPageChange" class="documentDropdown">
        <option v-for="(group, idx) in sortedDocumentGroups" :key="idx + 1" :value="idx + 1">
        {{ $t('view_document.header.document') }} {{ idx + 1 }} | {{ $t('view_document.header.vasion_status') }}: {{ group.vasion_status ? group.vasion_status.charAt(0).toUpperCase() + group.vasion_status.slice(1) : '-' }}</option>
      </select>
    </div>
  </div>
  <div class="viewDocumentContainer">
    <!-- Loading Overlay -->
    <!-- <div v-if="showLoadingOverlay" class="loading-overlay">
      <div class="loading-content">
        <div class="loading-spinner"></div>
        <div class="loading-text">{{ $t('view_document.messages.processing_documents') }}</div>
        <div class="progress-container">
          <div class="progress-bar" :style="{ width: extractionProgress + '%' }"></div>
          <div class="progress-text">{{ extractionProgress }}%</div>
        </div>
      </div>
    </div> -->

    <div class="newJobContainer">
      <div v-if="loading" style="width: 100%; display: flex; justify-content: center; align-items: center">
        <div v-if="loading" class="spinner-border text-primary spinner-grow-xl" role="status"></div>
      </div>

      <VasionConfirmationModal :show="showVasionModal" :loading="isSendingToVasion" @close="showVasionModal = false" @confirm="confirmSendToVasion" />
      <DocumentHistory :show="showDocumentHistory" :job-id="$route.query.jobId" @close="showDocumentHistory = false" :selectedResultDocument="selectedResultDocument" />
      <ViewSourceDocument :show="showSourceFile" :job-id="$route.query.jobId" @close="showSourceFile = false" :sourceFiles="sourceFiles" />
      <DeleteConfirmationModal :show="showDeleteConfirmModal" @close="handleDeleteConfirmClose" @confirm="confirmDelete" :message="delelteConfirmationMessage"/>
      <div v-if="!loading" class="row no-x-scroll">
        <div class="col-lg-6 viewDocumentFirstDiv" v-show="!isExpanded">
          <div class="pageHeaderViewDocument" style="position: sticky; top: -20px; z-index: 1200; background-color: white">
            <div class="pageHeaderViewDocumentTitle" style="cursor: pointer">
              <span @click="setExtractionTrue(false)" class="pageLabel">
                <svg v-if="isExtractionOpen" xmlns="http://www.w3.org/2000/svg" width="12" height="24" viewBox="0 0 12 24" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M3.34299 11.9977L10.414 19.0687L8.99999 20.4827L1.22199 12.7047C1.03451 12.5172 0.929199 12.2629 0.929199 11.9977C0.929199 11.7325 1.03451 11.4782 1.22199 11.2907L8.99999 3.5127L10.414 4.9267L3.34299 11.9977Z" fill="var(--primary-color)" />
                </svg>
                <span>{{ $t('view_document.navigation.classification_splitting') }}</span>
              </span>
              <span @click="setExtractionTrue(true)" class="pageLabel">
                <span style="margin-right: 10px">{{ $t('view_document.navigation.extraction') }}</span>

                <svg v-if="!isExtractionOpen" xmlns="http://www.w3.org/2000/svg" width="12" height="24" viewBox="0 0 12 24" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.65701 12.0004L1.58601 4.92935L3.00001 3.51535L10.778 11.2934C10.9655 11.4809 11.0708 11.7352 11.0708 12.0004C11.0708 12.2655 10.9655 12.5198 10.778 12.7074L3.00001 20.4854L1.58601 19.0714L8.65701 12.0004Z" fill="var(--primary-color)" />
                </svg>
              </span>
            </div>
            <!-- Add Tab Navigation for Line Items -->
            <div v-if="isExtractionOpen && hasLineItems" class="extraction-tabs" style="display: flex; border-bottom: 2px solid #e0e0e0;">
              <button 
                @click="activeTab = 'key-value'"
                :class="{ 'active-tab': activeTab === 'key-value' }"
                style="padding: 12px 16px; background: none; border: none; cursor: pointer; font-weight: 500; border-bottom: 3px solid transparent; margin-bottom: -2px; transition: all 0.2s;"
                :style="{ borderBottomColor: activeTab === 'key-value' ? 'var(--primary-color)' : 'transparent', color: activeTab === 'key-value' ? 'var(--primary-color)' : '#5c656c' }"
              >
                {{ $t('view_document.tabs.key_value_pairs') || 'Key-Value Pairs' }}
              </button>
              <button 
                @click="activeTab = 'line-items'"
                :class="{ 'active-tab': activeTab === 'line-items' }"
                style="padding: 12px 16px; background: none; border: none; cursor: pointer; font-weight: 500; border-bottom: 3px solid transparent; margin-bottom: -2px; transition: all 0.2s;"
                :style="{ borderBottomColor: activeTab === 'line-items' ? 'var(--primary-color)' : 'transparent', color: activeTab === 'line-items' ? 'var(--primary-color)' : '#5c656c' }"
              >
                {{ $t('view_document.tabs.line_items') || 'Line Items' }}
              </button>
            </div>
            <!-- <div class="documentViewHRNew"></div> -->
          </div>
          <div v-if="isExtractionOpen">
            <!-- Key-Value Pairs Tab (Default) -->
            <div v-if="activeTab === 'key-value'">
              <div v-if="Object.keys(filteredDocumentEntities).length === 0 || Object.values(filteredDocumentEntities).every((obj) => Object.keys(obj).length === 0)" class="no-data-message">
                <span v-if="!selectedImageSrc?.tenant_document_type?.id">{{ $t('view_document.extraction.not_classified') }}</span>
                <span v-else>{{ $t('view_document.extraction.in_progress') }}</span>
              </div>
              <div v-for="([fieldKey, field], index) in activeDocumentFields(filteredDocumentEntities)" :key="field.id + fieldKey" @click="findBoundingBox(field, field.value, selectedImageSrc?.file_name, Number(field?.score) <= 0)" class="input-container">
                <div v-if="activeDocumentFields(filteredDocumentEntities)?.length === 0" class="no-data-message">{{ $t('view_document.extraction.in_progress') }}</div>
                <div class="input-containerBox no-x-scroll">
                  <label class="inputLabel" :for="'input-' + field.id">
                    <div class="field-number">{{ index + 1 }}</div>
                    {{ field?.tenant_document_field?.vasion_field_name }}
                  </label>
                  <div class="input-field-container">
                    <div class="extraction-header">
                      <label
                        for=""
                        class="extractionConfidence"
                        :class="{
                          'text-black': field?.is_manual || field.isModified,
                          'text-red': Number(field?.score) <= 0,
                          'text-green': Number(field?.score) >= Number(field?.tenant_document_field?.ml_confidence_level),
                          'text-yellow': Number(field?.score) > 0 && Number(field?.score) < Number(field?.tenant_document_field?.ml_confidence_level),
                        }"
                        >{{ $t('view_document.extraction.confidence_level') }}: {{ field?.is_manual || field.isModified ? $t('view_document.extraction.manual') : Number(field?.score) <= 0 ? $t('view_document.extraction.na') : Number(field?.score).toFixed(0) + '' + '%' }}</label
                      >
                      <div v-if="field.isModified" class="modified-indicator" :title="$t('view_document.extraction.field_modified')">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" />
                          <path d="m15 5 4 4" />
                        </svg>
                      </div>
                    </div>
                    <!-- Dynamic input based on vasion_field_data_type -->
                    <!-- <template v-if="field?.tenant_document_field?.vasion_field_data_type === 'Date'">
                      <input :id="'input-' + field.id" :readonly="!isManual" v-model="field.value" type="date" class="dynamic-input" :class="{ activeImgNew: selectedInputIndex === field.id }" @focus="selectedInputIndex = field.id" @blur="selectedInputIndex = null" @input="checkFieldModification(field, selectedImageSrc?.mx_job_result_document_id)" @keydown="handleTabNavigation($event, index)" />
                    </template> -->
                    <template v-if="field?.tenant_document_field?.vasion_field_data_type === 'Dropdown'">
                      <select style="width: 399px !important; color: #5c656c !important" :id="'input-' + field.id" :disabled="!isManual || this.mainResponse?.job?.is_retention_expired" v-model="field.value" class="dynamic-input" :class="{ activeImgNew: selectedInputIndex === field.id }" @focus="selectedInputIndex = field.id" @blur="selectedInputIndex = null" @change="checkFieldModification(field, selectedImageSrc?.mx_job_result_document_id)" @keydown="handleTabNavigation($event, index)">
                        <option value="">Select an option</option>
                        <option v-for="option in getDropdownOptions(field)" :key="option" :value="option">
                          {{ option }}
                        </option>
                      </select>
                    </template>
                    <template v-else-if="field?.tenant_document_field?.vasion_field_data_type === 'Currency'">
                      <input
                        style="width: 399px !important"
                        :id="'input-' + field.id"
                        :readonly="!isManual"
                        v-model="field.value"
                        type="number"
                        step="0.01"
                        class="dynamic-input"
                        :class="{ activeImgNew: selectedInputIndex === field.id }"
                        @focus="selectedInputIndex = field.id"
                        @blur="selectedInputIndex = null; formatCurrency(field)"
                        @input="checkFieldModification(field, selectedImageSrc?.mx_job_result_document_id)"
                        @keydown="handleTabNavigation($event, index)"
                      />
                    </template>
                    <template v-else-if="field?.tenant_document_field?.vasion_field_data_type === 'Number'">
                      <input
                        style="width: 399px !important"
                        :id="'input-' + field.id"
                        :readonly="!isManual"
                        v-model="field.value"
                        type="number"
                        step="0.01"
                        class="dynamic-input"
                        :class="{ activeImgNew: selectedInputIndex === field.id }"
                        @focus="selectedInputIndex = field.id"
                        @blur="selectedInputIndex = null; formatNumber(field)"
                        @input="checkFieldModification(field, selectedImageSrc?.mx_job_result_document_id)"
                        @keydown="handleTabNavigation($event, index)"
                      />
                    </template>
                    <template v-else>
                      <!-- Default to text input for 'Text' type or any other type -->
                      <input style="width: 399px !important" :id="'input-' + field.id" :readonly="!isManual" v-model="field.value" type="text" class="dynamic-input" :class="{ activeImgNew: selectedInputIndex === field.id }" @focus="selectedInputIndex = field.id" @blur="selectedInputIndex = null" @input="checkFieldModification(field, selectedImageSrc?.mx_job_result_document_id)" @keydown="handleTabNavigation($event, index)" />
                    </template>
                    <div v-if="field.generating_summary" class="summary-generating-inline">
                      <span class="summary-text-small">Summary is being generated, Please check in moment</span>
                      <span class="generating-dot"></span>
                      <span class="generating-dot"></span>
                      <span class="generating-dot"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Line Items Tab -->
            <div v-if="activeTab === 'line-items' && hasLineItems">
              <div v-if="lineItemTables && lineItemTables.length === 0" class="no-data-message">
                {{ $t('view_document.line_items.no_data') || 'No line items found' }}
              </div>
              <LineItemsTable 
                v-for="(tableData, index) in lineItemTables"
                :key="index"
                :tableData="tableData"
                :allTableData="lineItemTables"
                :resultDocumentId="selectedImageSrc?.mx_job_result_document_id"
                :isManual="isManual"
                @highlight-geometry="highlightGeometryOnImage"
                @updated="handleLineItemsUpdated"
                @success="handleLineItemsSuccess"
                @error="handleLineItemsError"
              />
            </div>
          </div>
          <div v-if="!isExtractionOpen">
            <div v-if="isManual" class="doc-selection-header">
              <label class="select-all-checkbox">
                <input :disabled="!hasAnyChangedDocuments" type="checkbox" class="" @change="selectAllChangedDocuments" />
                <span class="checkbox-label">{{ $t('view_document.classification.select_all_updated') }}</span>
              </label>
            </div>
            <div v-for="(documentGroup, groupIndex) in sortedDocumentGroups" :key="groupIndex" :style="groupIndex > 0 ? { marginTop: '10px' } : {}" style="max-height: 500px; z-index: -1" class="doc-classification-card" :class="{ 'doc-classification-card-active': selectedImageSrc && documentGroup.data.includes(selectedImageSrc) }" @click="handleDocumentGroupSelect(documentGroup)">
              <div @click="handleDocumentGroupSelectNew(documentGroup)" class="pageHeaderViewDocument">
                <p class="viewDocumentLabel" @click="handleDocumentGroupSelectNew(documentGroup)">
                  <span class="document-serial-number">{{ groupIndex + 1 }}</span>
                  <span v-if="isManual && documentGroup.changed" class="document-change-indicator" :title="$t('view_document.classification.unsaved_changes')">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="12" cy="12" r="10" />
                      <line x1="12" y1="8" x2="12" y2="12" />
                      <line x1="12" y1="16" x2="12.01" y2="16" />
                    </svg>
                  </span>
                  <label class="doc-card-checkbox" v-if="isManual">
                    <input type="checkbox" v-model="documentGroup.checked" @click.stop />
                    <!-- <span class="checkmark"></span> -->
                  </label>
                  {{ $t('view_document.classification.source_document') }}:
                  <span class="document-name-truncated" :title="documentGroup?.document_name_full">
                    {{ documentGroup?.document_name?.length > 20 ? documentGroup?.document_name?.substring(0, 20) + '...' : documentGroup?.document_name }}
                  </span>
                
                  <span v-if="documentGroup.data.length === 0" class="cross-button" @click.stop="removeDocumentGroup(groupIndex)" :title="$t('view_document.classification.remove_empty_group')"> × </span>
                  <span
                    class="vasion-status-indicator"
                    :class="{
                      'vasion-status-completed': documentGroup?.vasion_status?.toLowerCase() === 'completed',
                      'vasion-status-pending': documentGroup?.vasion_status?.toLowerCase() === 'pending' || documentGroup?.vasion_status?.toLowerCase() === 'partial' || !documentGroup?.vasion_status,
                    }"
                    :title="`${$t('view_document.header.vasion_status')}: ${documentGroup?.vasion_status || $t('view_document.header.pending')}`"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="12" cy="12" r="10" />
                      <path d="m9 12 2 2 4-4" />
                    </svg>
                  </span>
                  <!-- <span class="vasion-status-text">Vasion Status</span> -->
                  <span
                    class="score"
                    :class="{
                      'text-green': Number(calculateDocumentGroupConfidence(documentGroup).averageConfidence) <= 0,
                      'text-green': Number(calculateDocumentGroupConfidence(documentGroup).averageConfidence) > 0 && calculateDocumentGroupConfidence(documentGroup).meetsThreshold,
                      'text-yellow': Number(calculateDocumentGroupConfidence(documentGroup).averageConfidence) > 0 && !calculateDocumentGroupConfidence(documentGroup).meetsThreshold,
                      'text-black': documentGroup.isNewlyCreated,
                    }"
                  >
                    {{ $t('view_document.extraction.confidence_level') }}:
                    <b>{{ documentGroup.isNewlyCreated ? $t('view_document.extraction.manual') : Number(calculateDocumentGroupConfidence(documentGroup).averageConfidence) <= 0 ? $t('view_document.extraction.manual') : calculateDocumentGroupConfidence(documentGroup).averageConfidence + '' + '%' }}</b>
                    <button class="delete-button" @click.stop="handleDelete(documentGroup, groupIndex)" :title="$t('view_document.buttons.delete') || 'Delete'">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="3 6 5 6 21 6"></polyline>
                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                        <line x1="10" y1="11" x2="10" y2="17"></line>
                        <line x1="14" y1="11" x2="14" y2="17"></line>
                      </svg>
                    </button>
                  </span>
                </p>
                  <!-- Add button after confidence level -->
                <div class="documentViewHR" @click="handleDocumentGroupSelectNew(documentGroup)"></div>
              </div>
              <div @click="handleDocumentGroupSelectNew(documentGroup)" class="categoryCollection">
                <div v-if="!isBedrock && !isTextract" @click="handleDocumentGroupSelectNew(documentGroup)" class="categoryContainer">
                  <p @click="handleDocumentGroupSelectNew(documentGroup)" class="categoryTitle">{{ $t('view_document.classification.primary_classification') }}</p>
                  <select class="categorySelect" :disabled="!isManual || this.mainResponse?.job?.is_retention_expired" @change="handleCategoryChange($event, documentGroup)">
                    <option value="">{{ $t('view_document.classification.select') }}</option>
                    <option v-for="category in documentGroup.categoryList" :key="category.id" :value="category.category_id" :selected="category.category_id === documentGroup.category_id">
                      {{ category.category_display_name || category.name }}
                    </option>
                  </select>
                </div>
                <div v-if="!isBedrock && !isTextract" @click="handleDocumentGroupSelectNew(documentGroup)" class="categoryContainer">
                  <p @click="handleDocumentGroupSelectNew(documentGroup)" class="categoryTitle">{{ $t('view_document.classification.sub_category') }}</p>
                  <select class="categorySelect" style="width: 180px" :disabled="!isManual || this.mainResponse?.job?.is_retention_expired" @change="handleDepartmentChange($event, documentGroup)">
                    <option>{{ $t('view_document.classification.select') }}</option>
                    <option v-for="department in documentGroup?.departmentList?.filter((d) => d.category_id === documentGroup.actual_category_id)" :key="department.id" :value="department.department_id" :selected="department.department_id === documentGroup.actual_department_id || department.department_display_name === documentGroup.actual_department_name">
                      {{ department.department_display_name || department.department_name }}
                    </option>
                  </select>
                </div>
                <div @click="handleDocumentGroupSelectNew(documentGroup)" class="categoryContainer">
                  <p @click="handleDocumentGroupSelectNew(documentGroup)" class="categoryTitle">{{ $t('view_document.classification.document_type') }}</p>
                  <select class="categorySelect" :disabled="!isManual || this.mainResponse?.job?.is_retention_expired" :value="documentGroup.tenant_document_type_id" @change="handleDocumentTypeChange($event, documentGroup,  groupIndex)">
                    <option value="">{{ $t('view_document.classification.select') }}</option>
                    <option v-for="type in isBedrock || isTextract ? documentGroup?.documentTypeList?.filter((d) => d.id === documentGroup?.tenant_document_type_id || (d.is_deleted === false && d.is_published === true)) : documentGroup?.documentTypeList?.filter((d) => d.department_id === documentGroup.actual_department_id || d.is_deleted === false)" :key="type.id" :value="type?.id" :disabled="type.is_deleted">
                      {{ formatString(type.document_type_display_name) }}
                      <!-- ({{ type?.id }} / {{ documentGroup.tenant_document_type_id }}) -->
                    </option>
                  </select>
                </div>
              </div>

              <!-- Draggable Section for Each Classification -->
              <draggable :disabled="!isManual" v-model="documentGroup.data" group="pages" class="pageCollection" @start="onDragStart" @end="onDragEnd($event, documentGroup)" :ref="`draggable_${documentGroup.mx_job_result_document_id}_${documentGroup.tenant_document_type_id}`" :chosen-class="'myChosenClass'" :animation="150" :force-fallback="true" :fallback-class="'fallback'" :fallback-on-body="true" :fallback-tolerance="3" :scroll-sensitivity="100" :scroll-speed="20">
                <div v-for="(file, index) in documentGroup.data" :key="index" class="pageContainerNew" :class="{ activeImg: selectedImageSrc === file }" @click="setSelectedImage(file)">
                  <div class="pageImgDiv">
                    <div style="display: flex; justify-content: center; align-items: center; padding: 10px; border-radius: 5px" v-if="this.mainResponse?.job?.is_retention_expired">
                      <span>Retention Expired</span>
                    </div>
                    <div v-else>
                      <img :id="file.id" :mx_job_result_document_id="file.mx_job_result_document_id" :src="file.file_name" class="pageImg" alt="PDF Page" />
                    </div>
                  </div>
                  <div
                    class="pageDivContent"
                    :class="{
                      pageDivContentActive: selectedImageSrc === file,
                    }"
                  >
                    <p
                      class="pageDivContentTexts"
                      :class="{
                        pageDivContentTextsActive: selectedImageSrc === file,
                      }"
                    >
                      {{ $t('view_document.document_viewer.page') }} {{ file?.original_page_number }}
                    </p>
                  </div>
                </div>
              </draggable>
            </div>
          </div>
          <div class="main-buttons">
            <!-- <div class="documentViewHR"></div> -->
            <div v-if="isExtractionOpen" class="button-container">
              <div class="button-row">
                <button v-if="isManual" :disabled="!hasModifiedFields || isSavingEntities" class="upload-button" @click="handleSaveEntities">
                  <span v-if="isSavingEntities">
                    {{ $t('loading') }}
                    <div class="spinner-border text-white spinner-grow-sm" role="status"></div>
                  </span>
                  <span v-else>{{ $t('view_document.buttons.save_entities') }}</span>
                </button>
                <button v-if="!selectedImageSrc?.tenant_document_type?.send_to_vasion_storage" class="upload-button" @click="handleStartWorkflow" :disabled="Object.keys(filteredDocumentEntities).length === 0 || hasModifiedFields || !getCurrentDocumentTypeData()?.vasion_workflow_id || isStartingWorkflow">
                  
                  <span >{{ $t('view_document.buttons.start_workflow') }}</span>
                </button>
                <div class="vasion-status-action-group">
                  <select v-model="selectedVasionStatus" class="vasion-status-dropdown">
                    <option value="" disabled selected>{{ $t('view_document.vasion_status_dropdown.select_status') }}</option>
                    <option v-if="getCurrentDocumentTypeData()?.vasion_folder_id" value="Approved">{{ $t('view_document.vasion_status_dropdown.approved') }}</option>
                    <option v-if="getCurrentDocumentTypeData()?.vasion_review_folder_id" value="Review">{{ $t('view_document.vasion_status_dropdown.review') }}</option>
                    <option v-if="getCurrentDocumentTypeData()?.vasion_rejection_folder_id" value="Rejection">{{ $t('view_document.vasion_status_dropdown.rejected') }}</option>
                    <option v-if="(this.mainResponse?.job?.vasion_status === 'failed' || this.mainResponse?.job?.status === 'failed') && getCurrentDocumentTypeData()?.vasion_failed_folder_id" value="Failed">{{ $t('view_document.header.failed') }}</option>
                  </select>
                  <button :disabled="!selectedVasionStatus || isSendingToVasion" class="vasion-send-btn" @click="handleSendToVasion(selectedVasionStatus)">
                    {{ $t('view_document.buttons.send_to_vasion') }}
                  </button>
                </div>
              </div>
            </div>
            <div v-if="isManual && !isExtractionOpen" class="button-container">
              <div class="button-row">
                <!-- <button
                  v-if="!isManual"
                  class="cancel-button"
                  style="width: 200px !important"
                  @click="handleCancel"
                >
                  Cancel
                </button> -->
                <button class="upload-button" @click="handleSplitNewDocument" :disabled="Number(this.sortedDocumentGroups?.length) === Number(this.mainResponse?.file_page_textract_details?.length) || this.mainResponse?.job?.is_retention_expired">{{ $t('view_document.buttons.split_new_document') }}</button>
                <button class="upload-button" @click="handleSave" :disabled="!hasChangedDocuments || this.mainResponse?.job?.is_retention_expired || isSaving">
                  <span v-if="isSaving">
                    {{ $t('loading') }}
                    <div class="spinner-border text-white spinner-grow-sm" role="status"></div>
                  </span>
                  <span v-else>{{ $t('view_document.buttons.save') }}</span>
                </button>
                <button class="upload-button" @click="handleStartExtraction" :disabled="!showStartExtractionButton || this.mainResponse?.job?.is_retention_expired || isExtractionInProgress">
                  <span v-if="isExtractionInProgress">
                    {{ $t('view_document.buttons.extracting') }}
                    <div class="spinner-border text-white spinner-grow-sm" role="status"></div>
                  </span>
                  <span v-else>{{ $t('view_document.buttons.start_entity_extraction') }}</span>
                </button>
                <button v-if="isExtractionInProgress" class="refresh-button" @click="fetchJobDetailsNew" :disabled="!isExtractionInProgress" :title="$t('view_document.buttons.refresh_extraction_status')">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
                    <path d="M3 3v5h5" />
                    <path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16" />
                    <path d="M16 21h5v-5" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div :class="['col-lg-6', { 'col-lg-12': isExpanded }]">
          <div class="documentViewContainer" :style="{ marginLeft: isExpanded ? '0' : '23px' }">
            <div class="documentViewHeader">
              <div style="display: flex; flex-direction: column; gap: 0px">
                <span class="pageLabel">
                  {{ $t('view_document.document_viewer.document_type') }} :
                  {{ formatString(selectedImageSrc?.tenant_document_type?.document_type_display_name) }}
                </span>
              </div>
              <div style="display: flex; align-items: center; gap: 12px">
                <span style="font-size: 13px">
                  {{ $t('view_document.document_viewer.document') }} :
                  {{ mainResponse?.job_files?.find((file) => file.id === selectedImageSrc?.mx_job_file_id)?.file_name?.length > 40 ? mainResponse?.job_files?.find((file) => file.id === selectedImageSrc?.mx_job_file_id)?.file_name?.substring(0, 40) + '...' : mainResponse?.job_files?.find((file) => file.id === selectedImageSrc?.mx_job_file_id)?.file_name || $t('view_document.document_viewer.unknown_document') }}
                </span>
                <button class="document-history-header-btn" @click="showDocumentHistory = true" :title="$t('view_document.document_viewer.view_history')" style="font-size: 13px; display: flex; align-items: center; gap: 6px">
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 20 20" fill="none" style="margin-right: 3px">
                    <circle cx="10" cy="10" r="9" stroke="white" stroke-width="2" fill="none" />
                    <path d="M10 5V10L13 13" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  <!-- {{ $t('view_document.document_viewer.view_history') }} -->
                </button>
                <button
                  class="document-history-header-btn"
                  @click="showSourceFile = true"
                  :title="$t('view_document.document_viewer.view_source_file')"
                  style="font-size: 13px; display: flex; align-items: center; gap: 6px ; margin-right: 8px"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 24 24"
                    fill="none"
                 
                  >
                    <path
                      d="M1 12C1 12 5 5 12 5s11 7 11 7-4 7-11 7S1 12 1 12z"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <circle
                      cx="12"
                      cy="12"
                      r="3"
                      stroke="white"
                      stroke-width="2"
                    />
                  </svg>
                </button>
              </div>
            </div>
            <div class="document-header-row">
              <div class="vasion-status-display" v-if="getFieldVasionStatus()">
                <span class="vasion-status-label">{{ $t('view_document.header.vasion_status') }}:</span>
                <span
                  class="vasion-status-value"
                  :class="{
                    'vasion-status-completed': getFieldVasionStatus()?.toLowerCase() === 'completed',
                    'vasion-status-pending': getFieldVasionStatus()?.toLowerCase() === 'pending' || getFieldVasionStatus()?.toLowerCase() === 'partial' || !getFieldVasionStatus(),
                  }"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="vasion-status-icon">
                    <circle cx="12" cy="12" r="10" />
                    <path d="m9 12 2 2 4-4" />
                  </svg>
                  {{ getFieldVasionStatus() || $t('view_document.header.pending') }}
                </span>
              </div>
              <div class="document-nav-buttons">
                <span class="pageLabel" :disabled="selectedDocumentGroupIndex <= 1" @click="goToPrevDocumentGroup" style="margin-right: 6px; display: flex; align-items: center; font-size: 14px; cursor: pointer">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" style="margin-right: 6px" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
                  </svg>
                  {{ $t('view_document.document_viewer.prev_document') }}
                </span>
                <span class="pageLabel" :disabled="selectedDocumentGroupIndex >= sortedDocumentGroups.length" @click="goToNextDocumentGroup" style="margin-left: 6px; display: flex; align-items: center; font-size: 14px; cursor: pointer">
                  {{ $t('view_document.document_viewer.next_document') }}
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" style="margin-left: 6px" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
                  </svg>
                </span>
              </div>
            </div>
            <div class="documentViewHR" style="margin-top: 10px; margin-bottom: 0px"></div>
            <div class="pdfViewerNew">
              <ImageHighlighter ref="imageHighlighter" :isExpanded="isExpanded" :imageSrc="selectedImageSrc ? selectedImageSrc.file_name : ''" :textData="Array.isArray(mainTextData) ? mainTextData : []" :magnifierEnabled="magnifierEnabled" :isRetentionExpired="this.mainResponse?.job?.is_retention_expired" :imageId="selectedImageSrc?.id" @imageRotated="handleImageRotated" />
            </div>
            <div class="pdfViewFooter">
              <div class="zoom-controls">
                <button @click="handleZoomIn" class="zoom-button" :title="$t('view_document.zoom_controls.zoom_in')">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="11" cy="11" r="8"></circle>
                    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                    <line x1="11" y1="8" x2="11" y2="14"></line>
                    <line x1="8" y1="11" x2="14" y2="11"></line>
                  </svg>
                </button>
                <button @click="handleZoomOut" class="zoom-button" :title="$t('view_document.zoom_controls.zoom_out')">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="11" cy="11" r="8"></circle>
                    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                    <line x1="8" y1="11" x2="14" y2="11"></line>
                  </svg>
                </button>
                <button @click="handleResetZoom" class="zoom-button" :title="$t('view_document.zoom_controls.reset_zoom')">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"></path>
                    <path d="M21 3v5h-5"></path>
                    <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"></path>
                    <path d="M3 21v-5h5"></path>
                  </svg>
                </button>
                <button @click="handlePrintCurrentDocument" class="zoom-button" :title="$t('view_document.zoom_controls.print_current_document')">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="6,9 6,2 18,2 18,9"></polyline>
                    <path d="M6,18H4a2,2 0 0,1-2-2V11a2,2 0 0,1,2-2H20a2,2 0 0,1,2,2v5a2,2 0 0,1-2,2H18"></path>
                    <polyline points="6,14 6,18 18,18 18,14"></polyline>
                  </svg>
                </button>
                <!-- Magnifier Button -->
                <button @click="toggleMagnifier" class="zoom-button" :class="{ active: magnifierEnabled }" :title="$t('view_document.zoom_controls.toggle_magnifier')">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="11" cy="11" r="8"></circle>
                    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                  </svg>
                </button>
                <!-- Rotate Button -->
                <button @click="handleRotate" class="zoom-button" :disabled="!selectedImageSrc?.id" :title="$t('view_document.rotate.rotate_image') || 'Rotate Image'">
                  <span style="font-size: 20px; color: #fff; display: flex; align-items: center">&#8634;</span>
                </button>
              </div>
              <div class="pageNavigation">
                <img src="/backward.svg" alt="" @click="navigateInnerPage('prev')" style="cursor: pointer" />
                <div class="pageInfo">
                  <span class="pageInfoText">{{ $t('view_document.document_viewer.page') }}</span>
                  <div class="pageNumbers">
                    {{ this.getSortedDocumentGroupsIndexPage(selectedImageSrc?.id) }}
                  </div>
                </div>
                <svg @click="navigateInnerPage('next')" xmlns="http://www.w3.org/2000/svg" width="15" height="25" viewBox="0 0 15 25" fill="none" style="cursor: pointer">
                  <g clip-path="url(#clip0_789_5556)">
                    <path d="M9.33359 12.7665L5.20497 16.8952C5.18787 16.9123 5.16495 16.9298 5.13263 16.9466C5.12978 16.948 5.12645 16.9492 5.11743 16.9492C5.06598 16.9492 5.03839 16.9369 5.00917 16.9106C4.99849 16.9007 4.98511 16.8859 4.98511 16.8261L4.98511 8.07075C4.98511 8.03543 4.99096 8.01915 4.99314 8.01403C4.99488 8.00993 4.99807 8.00348 5.00983 7.99295C5.02876 7.97601 5.04576 7.965 5.0636 7.95827C5.11068 7.98014 5.1748 8.01224 5.25767 8.05597L9.33359 12.1319C9.39271 12.191 9.43056 12.2468 9.4547 12.2985C9.47262 12.3368 9.4848 12.3845 9.4848 12.4492C9.4848 12.5139 9.47262 12.5616 9.4547 12.6C9.43056 12.6516 9.39271 12.7074 9.33359 12.7665Z" fill="#5C656C" stroke="#5C656C" />
                    <line x1="11.9988" y1="17.6211" x2="11.9988" y2="6.62109" stroke="#5C656C" />
                  </g>
                  <defs>
                    <clipPath id="clip0_789_5556">
                      <rect width="24" height="14" fill="white" transform="matrix(0 -1 1 0 0.5 24.5)" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div class="expandButton" @click="toggleExpand">
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                  <path d="M4.1861 20.875H7.65304C7.82147 20.875 7.96222 20.929 8.07529 21.037C8.18836 21.145 8.2453 21.2789 8.24609 21.4386C8.24688 21.5984 8.18995 21.7319 8.07529 21.8391C7.96063 21.9464 7.81988 22 7.65304 22H3.95837C3.68715 22 3.45942 21.913 3.27518 21.739C3.09094 21.565 2.99921 21.349 3.00001 21.091V17.5866C3.00001 17.4269 3.05694 17.2934 3.1708 17.1861C3.28467 17.0789 3.42581 17.0249 3.59424 17.0241C3.76266 17.0234 3.90341 17.0774 4.01649 17.1861C4.12956 17.2949 4.1861 17.4284 4.1861 17.5866V20.875ZM20.8151 20.875V17.5866C20.8151 17.4269 20.8716 17.2934 20.9847 17.1861C21.0986 17.0781 21.2397 17.0241 21.4081 17.0241C21.5766 17.0241 21.7173 17.0781 21.8304 17.1861C21.9435 17.2941 22 17.4276 22 17.5866V21.091C22 21.349 21.9083 21.565 21.7248 21.739C21.5414 21.913 21.314 22 21.0428 22H17.347C17.1793 22 17.0386 21.946 16.9247 21.838C16.8109 21.73 16.7539 21.5961 16.7539 21.4364C16.7539 21.2766 16.8109 21.1431 16.9247 21.0359C17.0386 20.9286 17.1793 20.875 17.347 20.875H20.8151ZM4.1861 5.125V8.41338C4.1861 8.57313 4.12916 8.70663 4.0153 8.81388C3.90143 8.92113 3.76029 8.97513 3.59186 8.97588C3.42344 8.97663 3.28269 8.92263 3.16962 8.81388C3.05654 8.70513 3.00001 8.57163 3.00001 8.41338V4.909C3.00001 4.65175 3.09173 4.43575 3.27518 4.261C3.45863 4.08625 3.68636 3.99925 3.95837 4H7.65304C7.82147 4 7.96222 4.054 8.07529 4.162C8.18836 4.27 8.2453 4.40388 8.24609 4.56363C8.24688 4.72338 8.18995 4.85688 8.07529 4.96413C7.96063 5.07138 7.81988 5.125 7.65304 5.125H4.1861ZM20.8151 5.125H17.347C17.1793 5.125 17.0386 5.071 16.9247 4.963C16.8109 4.855 16.7539 4.72113 16.7539 4.56138C16.7539 4.40163 16.8109 4.26813 16.9247 4.16088C17.0386 4.05363 17.1793 4 17.347 4H21.0428C21.314 4 21.5414 4.087 21.7248 4.261C21.9083 4.435 22 4.651 22 4.909V8.41338C22 8.57313 21.9431 8.70663 21.8292 8.81388C21.7153 8.92113 21.5746 8.97513 21.407 8.97588C21.2393 8.97663 21.0986 8.92263 20.9847 8.81388C20.8708 8.70513 20.8139 8.57163 20.8139 8.41338L20.8151 5.125Z" fill="white" />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Add this near the top of your template -->
  <ExtractionChangesModal :show="showExtractionChangesModal" @close="handleExtractionChangesClose" @confirm="handleExtractionChangesConfirm" />
  <ExtractionChangesModal :show="showExtractionChangesModalNew" @close="handleExtractionChangesCloseNew" @confirm="handleExtractionChangesConfirmNew" />
</template>
<script>
import { get, put, post, del } from '../../utils/api.js'
import ImageHighlighter from '../../components/ImageHighlighter.vue'
import Fuse from 'fuse.js'
import { nextTick } from 'vue'
import * as pdfjsLib from 'pdfjs-dist'
import { VueDraggableNext as Draggable } from 'vue-draggable-next'
import { showToast } from '@/utils/toast'
import VasionConfirmationModal from '@/components/VasionConfirmationModal/VasionConfirmationModal.vue'
import ExtractionChangesModal from '@/components/ExtractionChangesModal/ExtractionChangesModal.vue'
import DeleteConfirmationModal from '@/components/DeleteConfirmationModal/DeleteConfirmationModal.vue'
import { printDocumentGroup, printAllDocuments } from '@/utils/printUtils'
// eslint-disable-next-line no-unused-vars
pdfjsLib.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`

import DocumentHistory from '@/components/DocumentHistory/DocumentHistory.vue'
import ViewSourceDocument from '@/components/ViewSourceFile/ViewSourceFile.vue'
import { isAiMethodBedrock, isAiMethodTextract } from '@/utils/tenantUtils.js'
import LineItemsTable from '@/pages/ViewDocument/LineItemsTable.vue'
import { convertLineItemsToTable } from '@/utils/lineItemsHelper.js'

export default {
  components: {
    draggable: Draggable,
    ImageHighlighter,
    VasionConfirmationModal,
    ExtractionChangesModal,
    DeleteConfirmationModal,
    DocumentHistory,
    LineItemsTable,
    ViewSourceDocument
  },
  data() {
    return {
      isManual: this.$route.query.isManual,
      job: null,
      jobData: [],
      taskData: [],
      loading: true, // Start with loading true to prevent blank screen flash
      isExtractionOpen: false,
      pendingChanges: [],
      hasStartedDragging: false,
      documentTypes: [],
      mainResponse: [],
      documentEntitiesNew: [],
      categories: [],
      departments: [],
      currentPageIndex: 0,
      totalPages: 0,
      parsedEntities: [], // Store extracted entities here
      mainTextData: null,
      pdfUrl: 'new.pdf',
      currentPage: 1,
      textData: null,
      timestamp: Date.now(),
      documents: [], // Stores processed classification documents
      pageImages: [], // Holds images for the first category
      pageImages2: [], // Holds images for the second category
      documentId: null, // Document ID from route params
      selectedImageSrc: null, // Holds the first file_name by default
      selectedDocumentData: null, // Holds the first file_name by default
      selectedInputIndex: null,
      selectedDocument: 'Financial', // Simulating a document selection
      selectedCategory: '',
      selectedDepartment: '',
      selectedDocumentType: '',
      originalFieldValues: {}, // Add this to store original values
      originalClassificationValues: {}, // Store original classification values
      documentMappings: {
        Financial: {
          'General Patient Intake and Administrative Forms': ['Patient Registration Form', 'Consent to Treat Form', 'HIPAA Privacy Notice and Acknowledgment Form', 'Test Results Form'],
          'Billing and Insurance Forms': ['Prior Authorization Request Form'],
          'Tax-Related Documents-US': ['IRS Form 1099 (for contractors)', 'IRS Form W-2 (for employees)', 'IRS Form W-9'],
          'Accounts Payable and Receivable': ['Purchase Orders (POs)', 'Customer Invoices'],
        },
      },
      isExpanded: false,
      showVasionModal: false, // Add this line
      showDocumentHistory: false,
      showSourceFile: false,
      lastAction: null, // Add this line
      selectedDocumentId: null, // For header dropdown
      selectedPageId: null, // For page dropdown
      selectedDocumentGroupIndex: 1, // 1-based index for dropdown
      selectedDocuments: [], // Add this new data property
      isSaveSuccessful: false, // Add this new property to track save status
      isExtractionInProgress: false,
      extractionProgress: 0,
      extractionPollingInterval: null,
      showLoadingOverlay: false,
      showExtractionChangesModal: false,
      showExtractionChangesModalNew: false,
      pendingExtractionValue: null,
      pendingDocumentNavigationIndex: null, // Track pending document navigation
      hasUnsavedChanges: false, // Add this new property
      showStartExtractionButton: false,
      selectedVasionStatus: '',
      showVasionDropdown: false,
      magnifierEnabled: false, // Add this line
      selectedMxResultDocId: null,
      selectedResultDocument: null,
      isSendingToVasion: false,
      isStartingWorkflow: false,
      isSaving: false,
      isSavingEntities: false,
      activeTab: 'key-value', // Track active tab (key-value or line-items)
      lineItemTables: [], // Array of table objects from multiple LineItemGroups
      hasLineItems: false, // Flag to check if line items exist
      sourceFiles: [],
      showDeleteConfirmModal: false,
      documentToDelete: null,
      groupIndexToDelete: null,
      delelteConfirmationMessage:"Are you sure you want to delete this document ?"
    }
  },
  watch: {
    selectedCategory() {
      this.selectedDepartment = ''
      this.selectedDocumentType = ''
    },
    // Reset document type when department changes
    selectedDepartment() {
      this.selectedDocumentType = ''
    },
    selectedImageSrc: {
      async handler(newVal) {
        const currentDocGroup = this.getCurrentDocumentGroup()
        const resultDocumentName = currentDocGroup?.document_name_full
        const fileName = this.mainResponse?.job_files?.find((file) => file.id === currentDocGroup?.mx_job_file_id)?.file_name
        this.selectedResultDocument = {
          fileName,
          resultDocumentName,
        }

        if (newVal && newVal.mx_job_result_document_id && this.selectedMxResultDocId !== newVal.mx_job_result_document_id) {
          this.selectedMxResultDocId = newVal.mx_job_result_document_id
          // this.selectedResultDocumentName = newVal.mx
          try {
            await this.logDocumentAudit(newVal.mx_job_result_document_id, 'VIEW_DOCUMENT')
          } catch (auditError) {
            // Don't show error to user for audit logging failure
          }

          // If extraction screen is open, fetch entities for the newly selected file
          if (this.isExtractionOpen && newVal.mx_job_result_document_id) {
            this.fetchDocumentEntitiesForFile(newVal.mx_job_result_document_id)
            // Also fetch line items data
            const payload =  {
              mx_job_id: this.$route.query.jobId,
              mx_job_result_document_id: newVal.mx_job_result_document_id,
            }
            this.fetchLineItems(payload)
          }
        }
        this.parsedEntities = []
        if (!newVal || !newVal.entities) {
          this.parsedEntities = []
          return
        }
        const formattedData = this.documents?.find((nData) => {
          return nData?.title === newVal?.classification_type
        })
        // this.setSelectedImage()
        if (formattedData?.data && formattedData?.data.length > 0) {
          formattedData.data.forEach((sData) => {
            try {
              // Parse entities if it's a string
              const parsedEntities = typeof sData.entities === 'string' ? JSON.parse(sData.entities) : sData.entities

              // Create a Map to store unique objects by Type

              // Attach sData.file_name to each entity
              const abc = parsedEntities.map((entity) => ({
                ...entity, // Spread original entity data
                file_name: sData, // Add file_name from sData
                send_to_vasion_storage: sData.send_to_vasion_storage,
              }))

              this.parsedEntities.push(...abc) // Correctly push to parsedEntities array
            } catch (error) {
              this.parsedEntities = []
            }
          })
        }

        const uniqueEntitiesMap = new Map()

        // Loop through entities and keep only the first occurrence of each Type
        this.parsedEntities?.forEach((entity) => {
          if (!uniqueEntitiesMap.has(entity.Type)) {
            uniqueEntitiesMap.set(entity.Type, entity)
          }
        })

        // Convert Map values back to an array
        const parsedEntities = Array.from(uniqueEntitiesMap.values())
        if (newVal?.classification_type === 'Purchase Orders' || newVal?.classification_type === 'IRS Form W-9') {
          this.parsedEntities = parsedEntities
        }

        // Sync selectedDocumentGroupIndex with the current group
        const groupIdx = this.sortedDocumentGroups.findIndex((group) => {
          return group.data.some((page) => page.id === newVal?.id)
        })
        if (groupIdx !== -1) {
          this.selectedDocumentGroupIndex = groupIdx + 1
        }
      },
      immediate: true,
    },
    mainResponse: {
      immediate: true,
      handler(newVal) {
        if (newVal?.job_files && newVal.job_files.length > 0) {
          // Wait for next tick to ensure documents are processed
          this.$nextTick(() => {
            if (this.documents && this.documents.length > 0) {
              // if (docGroup && docGroup.data.length > 0) {
              //   this.setSelectedImage(docGroup.data[0])
              //   // Scroll to the highlighted image
              //   this.$nextTick(() => {
              //     const element = document.querySelector('.activeImg')
              //     if (element) {
              //       element.scrollIntoView({
              //         behavior: 'smooth',
              //         block: 'center',
              //       })
              //     }
              //   })
              // }
            } else if (this.selectedDocumentId === null) {
              this.selectedDocumentId = newVal.job_files[0].id
            }
          })
        }
      },
    },
    selectedDocumentId(newId) {
      // When dropdown changes, update selectedImageSrc to first page of that document
      if (!newId || !this.documents) return
      const docGroup = this.documents.find((group) => group.mx_job_file_id === newId)
      if (docGroup && docGroup.data.length > 0) {
        this.selectedPageId = docGroup.data[0].id
        this.setSelectedImage(docGroup.data[0])
      }
    },
    selectedPageId(newPageId) {
      // When page dropdown changes, update selectedImageSrc
      if (!newPageId || !this.pagesForSelectedDocument) return
      const page = this.pagesForSelectedDocument.find((p) => p.id === newPageId)
      if (page) {
        this.setSelectedImage(page)
      }
    },
    documentEntitiesNew: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          // Store original values when document entities are loaded
          Object.entries(newVal).forEach(([docId, docFields]) => {
            Object.entries(docFields).forEach(([fieldId, field]) => {
              const key = `${docId}_${fieldId}`
              this.originalFieldValues[key] = field.value
              // Add isModified flag
              field.isModified = false

              // Format Currency and Number fields on initial load
              const dataType = field?.tenant_document_field?.vasion_field_data_type
              if (dataType === 'Currency' || dataType === 'Number') {
                this.formatFieldValue(field)
              }
            })
          })
        }
      },
    },
    documents: {
      handler() {
        // No auto-selection of changed documents
        // this.selectedDocuments = this.sortedDocumentGroups.filter((group) => this.hasDocumentChanges(group)).map((group) => group.mx_job_file_id)
      },
      deep: true,
    },
  },
  created() {
    // Add beforeunload event listener
    window.addEventListener('beforeunload', this.handleBeforeUnload)

    // Fetch and parse job data from query params
    const jobData = this.$route.query.data
    const isManualJob = this.$route.query.isManual
    const documentId = this.$route.query.documentId // Get documentId from query params

    if (jobData) {
      this.job = JSON.parse(jobData)
    }

    // Set isManual based on the query parameter
    if (isManualJob !== undefined) {
      this.isManual = isManualJob === 'true' || isManualJob === true
    }

    // Store documentId for later use
    this.documentId = documentId
  },
  beforeUnmount() {
    // Remove beforeunload event listener
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
  },
  computed: {
    hasModifiedFields() {
      return Object.values(this.filteredDocumentEntities).some((field) => field.isModified)
    },
    filteredDocumentEntities() {
      const selectedId = this.selectedImageSrc?.tenant_document_type?.id
      const mx_job_file_id = this.selectedImageSrc?.mx_job_result_document_id

      if (!selectedId) return {}

      const entity = this.documentEntitiesNew[mx_job_file_id]

      // Protect against undefined
      if (!entity) return {}

      return entity || {}
    },
    activeDocumentFields() {
      return (documentFields) => {
        return Object.entries(documentFields).filter(([, field]) => field?.tenant_document_field?.is_active)
      }
    },
    sortedDocumentGroups() {
      if (this.hasStartedDragging) {
        return this.documents
      }
      // Cache the sorted result
      return this.documents.map((group) => ({
        ...group,
        data: [...group.data].sort((a, b) => a.mx_job_result_document_id - b.mx_job_result_document_id),
      }))
    },
    isBedrock() {
      return isAiMethodBedrock()
    },
    isTextract() {
      return isAiMethodTextract()
    },
    availableCategories() {
      return this.selectedDocument ? Object.keys(this.documentMappings[this.selectedDocument] || {}) : []
    },
    // Compute available departments based on selected category
    availableDepartments() {
      return this.availableCategories.includes(this.selectedCategory) ? Object.keys(this.documentMappings[this.selectedDocument]) : []
    },
    // Compute available document types based on selected department
    availableDocumentTypes() {
      return this.selectedDepartment ? this.documentMappings[this.selectedDocument][this.selectedDepartment] || [] : []
    },
    iframeUrl() {
      return `${this.pdfUrl}#page=${this.currentPage}`
      // return `https://maxdocument.s3.amazonaws.com/80cf0160-a4a1-4e77-a172-a909b154d0ab/merge.pdf?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAXBZV5ITW6M3RTQPC%2F20250205%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20250205T025114Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Signature=b36b252a57687b6e1c545d78e5701c19ed237ebf16f1248fdd009e7bab4d22a4`
    },
    pagesForSelectedDocument() {
      const docGroup = this.documents.find((group) => group.mx_job_file_id === this.selectedDocumentId)
      return docGroup && docGroup.data ? docGroup.data : []
    },
    hasChangedDocuments() {
      return this.sortedDocumentGroups.some((group) => group?.checked)
    },
    hasAnyChangedDocuments() {
      return this.sortedDocumentGroups.some((group) => group.changed)
    },
    areAllChangedDocumentsSelected: {
      get() {
        return this.sortedDocumentGroups.every((group) => group.checked)
      },
      set(value) {
        this.sortedDocumentGroups.forEach((group) => {
          group.checked = value
        })
      },
    },
  },
  async mounted() {
    // Set loading to true immediately to prevent blank screen flash
    this.loading = true

    // 2) On component mount, load the PDF
    this.documentId = this.$route?.query?.documentId
    const jobId = this.$route?.query?.jobId

    if (jobId) this.logJobAudit(jobId, 'VIEW_JOB')

    // Fetch reference data first based on AI method
    if (this.isBedrock || this.isTextract) {
      // For Bedrock mode, fetch all document types directly BEFORE fetching job details
      await this.fetchAllDocumentTypes()
    } else {
      // For non-Bedrock mode, fetch categories and departments
      await Promise.all([this.fetchCategories(), this.fetchDepartments()])
    }

    // Then fetch jobs after reference data is loaded (this will set loading to false when done)
    await this.fetchJobs()

    document.addEventListener('mousedown', this.handleMouseDownDisableMagnifier)
  },
  unmounted() {
    // ... existing code ...
    document.removeEventListener('mousedown', this.handleMouseDownDisableMagnifier)
  },
  methods: {
    updateCategory(index, newCategory) {},
    formatString(input) {
      // Split only on the first two underscores
      if (!input) return ''
      const parts = input.split('_')

      // If fewer than 3 parts, nothing to format
      if (parts.length < 3) return input

      // Join everything after the second underscore
      const rest = parts.slice(2).join('_')

      // Replace _ and - with space
      return rest.replace(/[_-]/g, ' ')
    },
    getDropdownOptions(field) {
      // Extract dropdown options from the field data
      // This assumes the options are stored in a specific property
      // You may need to adjust this based on your actual data structure
      const options = field?.tenant_document_field?.dropdown_options || field?.tenant_document_field?.vasion_drop_down_values || field?.options || []

      // If options is a string, try to parse it as JSON first, then as comma-separated
      if (typeof options === 'string') {
        try {
          // Try to parse as JSON first (for cases like "[\"Option1\",\"Option2\"]")
          const parsedOptions = JSON.parse(options)
          if (Array.isArray(parsedOptions)) {
            return parsedOptions
          }
        } catch (e) {
          // If JSON parsing fails, treat as comma-separated string

          return options
            .split(',')
            .map((opt) => opt.trim())
            .filter((opt) => opt)
        }
      }

      // If options is already an array, return it
      if (Array.isArray(options)) {
        return options
      }
      // Default to empty array if no options found
      return []
    },
    formatFieldValue(field) {
      if (!field.value) return

      // Convert to number if it's not already
      let numValue = parseFloat(field.value)

      // If conversion fails, keep original value
      if (isNaN(numValue)) {
        return
      }

      // Format to 2 decimal places
      field.value = numValue.toFixed(2)
    },
    formatCurrency(field) {
      this.formatFieldValue(field)
    },
    formatNumber(field) {
      this.formatFieldValue(field)
    },
    getSortedDocumentGroupsIndex(selectedImageSrcId) {
      const selectedImageIndex = this.sortedDocumentGroups.findIndex((group) => group.data.some((item) => item.id === selectedImageSrcId))
      return selectedImageIndex + 1
    },
    getSortedDocumentGroupsIndexPage(selectedImageSrcId) {
      // Find the group containing the selected image
      const selectedGroup = this.sortedDocumentGroups.find((group) => group.data.some((item) => item.id === selectedImageSrcId))

      if (!selectedGroup) return '0/0'

      // Find the index of the current image within its group
      const currentImageIndex = selectedGroup.data.findIndex((item) => item.id === selectedImageSrcId)

      return `${currentImageIndex + 1}/${selectedGroup.data.length}`
    },
    findBestMatches(allBoundingBoxes, selectedText) {
      const cleanText = (text) =>
        text
          .replace(/[^a-zA-Z0-9 ]/g, '') // Remove special characters
          .trim()
          .toLowerCase()

      const words = selectedText.split(/\s+/).map((word) => word.toLowerCase())

      // Step 1: Check for exact match
      let foundBoxes = allBoundingBoxes.filter((box) => box.Text.toLowerCase() === selectedText.toLowerCase())

      // Step 2: If no exact match, check for individual word matches
      if (foundBoxes.length === 0) {
        foundBoxes = allBoundingBoxes.filter((box) => words.some((word) => box.Text.toLowerCase().includes(word.toLowerCase())))
      }

      // Step 3: If still no match, remove special characters and try again
      if (foundBoxes.length === 0) {
        const cleanedText = cleanText(selectedText)
        const cleanedWords = cleanedText.split(/\s+/)

        foundBoxes = allBoundingBoxes.filter((box) => cleanedWords.some((word) => cleanText(box.Text).includes(word)))
      }

      // Step 4: If still no match, apply Fuse.js fuzzy search
      if (foundBoxes.length === 0) {
        const options = {
          keys: ['Text'], // Field to search
          threshold: 0.4, // Adjust sensitivity (lower = stricter, higher = looser)
        }

        const fuse = new Fuse(allBoundingBoxes, options)
        foundBoxes = fuse.search(selectedText).map((result) => result.item)
      }

      return foundBoxes
    },

    async fetchJobs() {
      try {
        this.loading = true
        await Promise.all([this.fetchDocumentTypes(), this.fetchJobDetails()])
      } catch (error) {
      } finally {
        this.loading = false
      }
    },

    async fetchJobDetailsNew() {
      showToast({
        title: this.$t('view_document.messages.refresh_job.title'),
        message: this.$t('view_document.messages.refresh_job.message'),
        type: 'success',
      })
      this.fetchJobDetails()
    },
    async fetchJobDetails() {
      const response = await get(`/v1/mx-jobs/details/${this.$route.query.jobId}`)
      this.mainResponse = response?.data
      // Check if job status is inprogress
      if (this.mainResponse?.job?.status === 'inprogress') {
        this.isExtractionInProgress = true
        // Start polling for updates
        this.startPollingForUpdates()
      } else {
        this.isExtractionInProgress = false
        if (this.extractionPollingInterval) {
          clearInterval(this.extractionPollingInterval)
        }
      }

      // Initialize documentEntitiesNew as empty object - we'll load data per file
      this.documentEntitiesNew = {}
      this.sourceFiles = response.data.job_files
      const sortedFilePageTextractDetails = [...(response?.data?.file_page_textract_details || [])].sort((a, b) => (a?.original_page_number || 0) - (b?.original_page_number || 0))
      const documentGroups = sortedFilePageTextractDetails.reduce((acc, item) => {
        const mx_job_result_document_id = item.mx_job_result_document_id
        const groupKey = `${mx_job_result_document_id}_` // Create a unique key combining both IDs
        const result_document = response?.data?.result_document?.find((file) => file.id === mx_job_result_document_id)
        const vasion_status = result_document?.vasion_status
        // const vasion_status = item?.vasion_status
        const document_name = result_document?.file_name?.length > 40 ? result_document?.file_name.substring(0, 40) + '...' : result_document?.file_name || '---'
        if (!acc[groupKey]) {
          // Create new group for unique document type and job file combination
          acc[groupKey] = {
            title: item.tenant_document_type_name,
            tenant_document_type: item.tenant_document_type,
            category: item.tenant_document_type?.category?.category_name,
            category_id: item.tenant_document_type?.category?.id,
            department_id: item.tenant_document_type?.department?.id,
            department: item.tenant_document_type?.department?.department_name,
            data: [],
            tenant_document_type_id: item.tenant_document_type_id,
            page_count: item?.tenant_document_type?.page_count,
            mx_job_file_id: item.mx_job_file_id,
            actual_document_type: item?.tenant_document_type?.document_type?.id,
            actual_document_type_name: item?.tenant_document_type?.document_type?.document_type_name,
            group_id: item?.group_id,
            actual_category_name: item?.tenant_document_type?.category?.category_name,
            actual_category_id: item?.tenant_document_type?.category?.id,
            actual_department_name: item?.tenant_document_type?.department?.department_name,
            actual_department_id: item?.tenant_document_type?.document_type?.department_id,
            document_name: document_name,
            mx_job_result_document_id: item.mx_job_result_document_id,
            document_name_full: result_document?.file_name || '---',
            ml_confidence_level: item?.tenant_document_type?.ml_confidence_level,
            categoryList: this.categories,
            departmentList: this.departments,
            documentTypeList: this.documentTypes,
            changed: false,
            checked: false,
            vasion_status: vasion_status,
          }
        }

        // Add document data with updated field mappings
        acc[groupKey].data.push({
          ...item,
          file_name: item.image_file,
          score: item.confidence,
          isDragged: false,
          changed: false,
          checked: false,
        })
        return acc
      }, {})

      // Convert to array format
      this.documents = Object.values(documentGroups)

      // For Bedrock and textract, ensure document groups have the latest documentTypeList
      if (this.isBedrock || this.isTextract) {
        this.documents.forEach((group) => {
          group.documentTypeList = this.documentTypes
        })
        // Wait for Vue to update the DOM with the new document types
        await nextTick()
      }

      // Store original classification values for each document group
      this.documents.forEach((group) => {
        this.originalClassificationValues[group.mx_job_file_id] = {
          category_id: group.category_id,
          actual_category_id: group.actual_category_id,
          department_id: group.department_id,
          actual_department_id: group.actual_department_id,
          tenant_document_type_id: group.tenant_document_type_id,
          actual_document_type: group.actual_document_type,
          actual_document_type_name: group.actual_document_type_name,
        }
      })

      // Try to select image based on URL parameters (imageId takes priority, then documentId)
      const imageIdFromUrl = this.$route.query.imageId
      const documentIdFromUrl = this.$route.query.documentId

      if (imageIdFromUrl) {
        // Find image by imageId from URL
        let foundImage = null
        for (const group of this.sortedDocumentGroups) {
          const image = group.data.find((page) => Number(page.id) === Number(imageIdFromUrl))
          if (image) {
            foundImage = image
            const groupIndex = this.sortedDocumentGroups.findIndex((g) => g === group)
            if (groupIndex !== -1) {
              this.selectedDocumentGroupIndex = groupIndex + 1
            }
            break
          }
        }

        if (foundImage) {
          // Skip URL update when restoring from URL params
          this.setSelectedImage(foundImage, true)
          // Add delay before scrolling
          setTimeout(() => {
            const element = document.querySelector('.activeImg')
            if (element) {
              element.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
              })
            }
          }, 1000) // 1 second delay
          return
        }
      }

      // Fall back to documentId if imageId not found
      if (documentIdFromUrl) {
        const docGroup = this.sortedDocumentGroups.find((group) => {
          return group?.data?.find((subGroup) => Number(subGroup?.mx_job_result_document_id) === Number(documentIdFromUrl))
        })
        if (docGroup && docGroup.data.length > 0) {
          // Skip URL update when restoring from URL params
          this.setSelectedImage(docGroup.data[0], true)
          const groupIndex = this.sortedDocumentGroups.findIndex((group) => group === docGroup)
          if (groupIndex !== -1) {
            this.selectedDocumentGroupIndex = groupIndex + 1 // Convert to 1-based index
          }
          // Add delay before scrolling
          setTimeout(() => {
            const element = document.querySelector('.activeImg')
            if (element) {
              element.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
              })
            }
          }, 1000) // 1 second delay
          return
        }
      }

      // Default: Set first document as default selection if available
      if (this.documents.length > 0 && this.documents[0].data.length > 0) {
        this.selectedImageSrc = this.documents[0].data[0]
        this.selectedDocumentData = this.documents[0]
        this.selectedDocumentGroupIndex = 1 // Initialize to first document
      }
    },

    async fetchDocumentEntitiesForFile(fileId) {
      // Check if data is already loaded
      if (this.documentEntitiesNew[fileId]) {
        return
      }

      try {
        const payload =  {
          mx_job_id: this.$route.query.jobId,
          mx_job_result_document_id: fileId,
        }
        await this.fetchLineItems(payload)
        // Fetch document entities for the specific file
        const response = await get(`/v1/mx-document-entities`, payload)

        // Store the fetched data - response.data is the object keyed by fileId
        if (response?.data) {
          // Merge the response data into documentEntitiesNew
          // Response should be { [fileId]: { [fieldId]: field } }
          this.documentEntitiesNew = { ...this.documentEntitiesNew, ...response.data }

          // Store original values for the newly loaded entities
          if (response.data[fileId]) {
            const docFields = response.data[fileId]
            Object.entries(docFields).forEach(([fieldId, field]) => {
              const key = `${fileId}_${fieldId}`
              this.originalFieldValues[key] = field.value
              field.isModified = false

              // Format Currency and Number fields on initial load
              const dataType = field?.tenant_document_field?.vasion_field_data_type
              if (dataType === 'Currency' || dataType === 'Number') {
                this.formatFieldValue(field)
              }
            })
          }
        }
   
      } catch (error) {
        console.error('Error fetching document entities for file:', error)
        // Initialize empty object if API call fails
        this.documentEntitiesNew = { ...this.documentEntitiesNew, [fileId]: {} }
      }
    },

    startPollingForUpdates() {
      // Clear any existing interval
      if (this.extractionPollingInterval) {
        clearInterval(this.extractionPollingInterval)
      }

      // Start polling every 5 seconds
      this.extractionPollingInterval = setInterval(async () => {
        try {
          const response = await get(`/v1/mx-jobs/details/${this.$route.query.jobId}`)
          if (response?.data?.job?.status !== 'inprogress') {
            this.isExtractionInProgress = false
            clearInterval(this.extractionPollingInterval)
            // Refresh the data
            await this.fetchJobDetails()
            this.showStartExtractionButton = false
          }
        } catch (error) {
          clearInterval(this.extractionPollingInterval)
          this.isExtractionInProgress = false
        }
      }, 5000)
    },

    findBoundingBox(filed, selectedText, fileData, score) {
      // console.log('selectedText', filed,fileData)
      if (score || filed?.key === 'DocumentType_Field' || filed?.tenant_document_field?.vasion_field_data_type === 'Dropdown' || this.selectedImageSrc?.image_rotated === true) return
      const mx_file_page_textract_detail_id = filed?.mx_file_page_textract_detail_id
      const page_number = filed?.geometry?.page
      const aiMethod = this.mainResponse?.job?.ai_method === 'Bedrock Data Automation'
      // if (page_number !== 0) {
      let mx_file_page_textract_detail
      if (aiMethod) {
        // Filter data by mx_job_result_document_id
        let filteredDetails = this.mainResponse?.file_page_textract_details?.filter((data) => data?.mx_job_result_document_id === filed?.mx_job_result_document_id) || []
        // Sort by page_number ascending
        filteredDetails.sort((a, b) => (a?.page_number || 0) - (b?.page_number || 0))
        // Assign the correct page (page_number - 1)
        mx_file_page_textract_detail = filteredDetails[page_number - 1]
      } else {
        mx_file_page_textract_detail = this.mainResponse?.file_page_textract_details?.find((item) => item.id === mx_file_page_textract_detail_id)
      }
      if (mx_file_page_textract_detail) {
        // Set additional fields
        mx_file_page_textract_detail.file_name = mx_file_page_textract_detail.image_file
        mx_file_page_textract_detail.score = mx_file_page_textract_detail.confidence
      }

      if (mx_file_page_textract_detail) {
        this.setSelectedImage(mx_file_page_textract_detail) // First update the selected image
      }
      nextTick(() => {
        let allBoundingBoxes = this.selectedImageSrc?.bounding_box ? JSON.parse(this.selectedImageSrc?.bounding_box) : filed?.geometry?.boundingBox

        if (allBoundingBoxes) {
          const foundBoxes = this.selectedImageSrc?.bounding_box ? this.findBestMatches(allBoundingBoxes, selectedText) : allBoundingBoxes

          if (foundBoxes.length === 0) {
          } else {
          }

          // Assign data to mainTextData & force Vue to re-render
          if (this.selectedImageSrc?.bounding_box) {
            this.mainTextData = foundBoxes.length > 0 ? foundBoxes : []
          } else {
            // Format data in the required structure when bounding_box doesn't exist
            const boundingBox = allBoundingBoxes
              ? {
                  Width: allBoundingBoxes.width || allBoundingBoxes.Width || 0,
                  Height: allBoundingBoxes.height || allBoundingBoxes.Height || 0,
                  Left: allBoundingBoxes.left || allBoundingBoxes.Left || 0,
                  Top: allBoundingBoxes.top || allBoundingBoxes.Top || 0,
                }
              : {
                  Width: 0,
                  Height: 0,
                  Left: 0,
                  Top: 0,
                }

            this.mainTextData = [
              {
                BoundingBox: boundingBox,
                Text: selectedText || '',
                Confidence: filed?.tenant_document_field?.ml_confidence_level || 0,
              },
            ]
          }
        }
      })
      // }
    },
    getCategoryAndDepartment(title) {
      if (!title) return { department: '', category: '' }

      const documentMap = {
        'IRS Form W-9': {
          department: 'Tax-Related Documents-US',
          category: 'Financial Documents',
        },
        'IRS Form W-2 (for employees)': {
          department: 'Tax-Related Documents-US',
          category: 'Financial Documents',
        },
        'IRS Form 1099 (for contractors)': {
          department: 'Tax-Related Documents-US',
          category: 'Financial Documents',
        },
        'Purchase Orders (POs)': {
          department: 'Accounts Payable and Receivable',
          category: 'Financial Documents',
        },
        'Purchase Orders': {
          department: 'Accounts Payable and Receivable',
          category: 'Financial Documents',
        },
        'Customer Invoices': {
          department: 'Accounts Payable and Receivable',
          category: 'Financial Documents',
        },
        'Prior Authorization Request Form': {
          department: 'Billing and Insurance Forms',
          category: 'Healthcare / Medical Forms',
        },
        'Test Results Form': {
          department: 'General Patient Intake and Administrative Forms',
          category: 'Healthcare / Medical Forms',
        },
        'HIPAA Privacy Notice and Acknowledgment Form': {
          department: 'General Patient Intake and Administrative Forms',
          category: 'Healthcare / Medical Forms',
        },
        'Consent to Treat Form': {
          department: 'General Patient Intake and Administrative Forms',
          category: 'Healthcare / Medical Forms',
        },
        'Patient Registration Form': {
          department: 'General Patient Intake and Administrative Forms',
          category: 'Healthcare / Medical Forms',
        },
        'Living Will': {
          department: 'Estate Planning and Wills',
          category: 'Legal',
        },
        'Divorce Agreement': {
          department: 'Family and Personal Legal Documents',
          category: 'Legal',
        },
        'Promissory Note': {
          department: 'Contracts and Agreements',
          category: 'Legal',
        },
        'Sales Agreement': {
          department: 'Contracts and Agreements',
          category: 'Legal',
        },
        'Background Check Authorization Form': {
          department: 'Recruitment and Onboarding',
          category: 'HR - Human Resources',
        },
        'Employment Application Form': {
          department: 'Recruitment and Onboarding',
          category: 'HR - Human Resources',
        },
        'Selective Service Registration Form': {
          department: 'Military and Selective Service',
          category: 'Government',
        },
        'Form I-90 – Application to Replace Permanent Resident Card': {
          department: 'Immigration and Citizenship',
          category: 'Government',
        },
        'Form N-400 – Application for Naturalization': {
          department: 'Immigration and Citizenship',
          category: 'Government',
        },
      }

      return documentMap[title.trim()] || { department: '', category: '' }
    },
    groupByClassificationType(responseData) {
      return Object.entries(
        responseData.reduce((acc, item) => {
          const classificationType = item.classification_type
          if (!acc[classificationType]) {
            acc[classificationType] = []
          }
          acc[classificationType].push(item)
          return acc
        }, {})
      ).map(([classificationType, items]) => {
        return {
          title: classificationType,
          department: this.getCategoryAndDepartment(classificationType).department || '',
          category: this.getCategoryAndDepartment(classificationType).category || '',
          data: items,
        }
      })
    },

    setSelectedImage(file, skipUrlUpdate = false) {
      this.setMainTextDataToNull()
      this.selectedImageSrc = file

      // Update current page index when setting a new image
      const currentGroup = this.documents.find((group) => group.data.some((page) => page.id === file?.id))

      if (currentGroup) {
        this.currentPageIndex = currentGroup.data.findIndex((page) => page?.id === file?.id)
        this.totalPages = currentGroup.data.length

        // Update selectedDocumentGroupIndex based on the current group's position
        const groupIndex = this.sortedDocumentGroups.findIndex((group) => group === currentGroup)
        if (groupIndex !== -1) {
          this.selectedDocumentGroupIndex = groupIndex + 1 // Convert to 1-based index
          this.image_rotated = file?.image_rotated
        }
      }

      // Update URL with documentId and imageId to remember selected image (unless restoring from URL)
      if (!skipUrlUpdate && file?.id && file?.mx_job_result_document_id) {
        const tenantName = localStorage.getItem('url_name')
        const query = { ...this.$route.query }
        query.documentId = file.mx_job_result_document_id
        query.imageId = file.id

        // Update URL without reloading the page
        this.$router
          .replace({
            name: 'view-document',
            params: { tenantName },
            query: query,
          })
          .catch(() => {
            // Ignore navigation errors
          })
      }
    },
    async handleImageRotated() {
      // After rotating image, reload the page to get updated image URL
      // The URL already contains documentId and imageId, so it will automatically select the correct image
      window.location.reload()
    },
    setExtractionTrue(value) {
      if(value === false) {
        setTimeout(() => {
            const element = document.querySelector('.doc-classification-card-active')
            if (element) {
              element.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
              })
            }
          }, 100)
      }
      if (this.isExtractionInProgress || this.mainResponse?.job?.is_retention_expired) return
      // Check if there are any modified fields
      const hasModifiedFields = Object.values(this.filteredDocumentEntities).some((field) => field.isModified)
      // Check if multiple documents are selected
      const hasMultipleSelectedDocuments = this.selectedDocuments.length >= 1

      // Check if any document groups have been changed
      const hasChangedDocumentGroups = this.documents.some((group) => group.changed)
      if (hasModifiedFields || hasMultipleSelectedDocuments || hasChangedDocumentGroups) {
        this.pendingExtractionValue = value
        this.showExtractionChangesModal = true
      } else {
        this.setMainTextDataToNull()
        // If opening extraction screen, fetch entities for the selected file if not already loaded
        if (value === true && this.selectedImageSrc?.mx_job_result_document_id) {
          this.fetchDocumentEntitiesForFile(this.selectedImageSrc.mx_job_result_document_id)
        }
        this.isExtractionOpen = value
      }
    },
    setMainTextDataToNull() {
      this.mainTextData = null
    },
    async loadPdf(pdfUrl) {
      try {
        // Create the loading task
        const loadingTask = pdfjsLib.getDocument(pdfUrl)
        const pdf = await loadingTask.promise

        // For each page, render a thumbnail
        for (let pageNumber = 1; pageNumber <= pdf.numPages; pageNumber++) {
          const page = await pdf.getPage(pageNumber)
          // Scale down for thumbnail (adjust scale to your liking)
          const viewport = page.getViewport({ scale: 0.3 })

          // Create a canvas to draw the page
          const canvas = document.createElement('canvas')
          const ctx = canvas.getContext('2d')
          canvas.width = viewport.width
          canvas.height = viewport.height

          // Render the page into the canvas
          const renderTask = page.render({
            canvasContext: ctx,
            viewport: viewport,
          })
          await renderTask.promise

          // Convert the canvas to an image data URL
          const dataUrl = canvas.toDataURL('image/png')
          this.pageImages.push(dataUrl)
          this.pageImages2.push(dataUrl)
        }
      } catch (error) {}
    },
    onDragStart() {
      // Optimize drag start by using requestAnimationFrame
      requestAnimationFrame(() => {
        this.hasStartedDragging = true
      })
    },
    onDragEnd(evt, documentGroup) {
      // Optimize drag end by batching updates
      const updateData = () => {
        const newIndex = evt.newIndex
        const oldGroup = evt.from
        const newGroup = evt.to

        // Log detailed information about the dragged item
        const draggedImage = evt.item.querySelector('img')
        const imageId = draggedImage ? draggedImage.id : null
        const mx_job_result_document_id = draggedImage ? draggedImage.getAttribute('mx_job_result_document_id') : null

        // Find the destination document group using the event's to property
        const destinationDocGroup = this.documents.find((doc) => {
          const draggableRefs = this.$refs[`draggable_${doc.mx_job_result_document_id}_${doc.tenant_document_type_id}`]
          // Handle both array and single ref cases
          const draggableRef = Array.isArray(draggableRefs) ? draggableRefs[0] : draggableRefs
          return draggableRef && draggableRef.$el === newGroup
        })

        if (oldGroup !== newGroup) {
          const targetDocGroup = this.documents.find((doc) => {
            const draggableRefs = this.$refs[`draggable_${doc.mx_job_result_document_id}_${doc.tenant_document_type_id}`]
            // Handle both array and single ref cases
            const draggableRef = Array.isArray(draggableRefs) ? draggableRefs[0] : draggableRefs
            return draggableRef && draggableRef.$el === newGroup
          })
          if (targetDocGroup && documentGroup.data[newIndex]) {
            const updatedItem = {
              ...documentGroup.data[newIndex],
              tenant_document_type_id: targetDocGroup.tenant_document_type_id,
              tenant_document_type: targetDocGroup.tenant_document_type,
              mx_job_file_id: targetDocGroup.mx_job_file_id,
              mx_job_result_document_id: mx_job_result_document_id,
              isDragged: true,
              sourceImageId: imageId,
              original_mx_job_file_id: documentGroup.mx_job_file_id, // Store original job file ID
              original_mx_job_result_document_id: documentGroup.mx_job_result_document_id, // Store original job file ID
            }

            // Update the item in place
            documentGroup.data[newIndex] = updatedItem
          }
        }

        // Batch update page numbers and flags - only mark specific moved files as changed
        const updatedDocuments = this.documents.map((group) => {
          // Check if this group is involved in the drag operation
          const isSourceGroup = group?.mx_job_result_document_id === documentGroup?.mx_job_result_document_id

          const isTargetGroup = destinationDocGroup && group.mx_job_result_document_id === destinationDocGroup?.mx_job_result_document_id
          return {
            ...group,
            data: group.data.map((item, index) => ({
              ...item,
              page_number: index + 1,
              sourceImageId: imageId,
              isDraggedNew: imageId.toString() !== item.id.toString(),
            })),
            changed: isSourceGroup || isTargetGroup ? true : group.changed,
            checked: isSourceGroup || isTargetGroup ? true : group.checked,
            document_name: group?.split_document ? documentGroup?.document_name : group?.document_name_full,
            document_name_full: group?.split_document ? documentGroup?.document_name_full : group?.document_name_full,
          }
        })

        // Single update to documents array
        this.documents = updatedDocuments
      }

      // Use requestAnimationFrame for smoother updates
      requestAnimationFrame(updateData)
    },

    getReturnRoute() {
      const from = this.$route.query.from
      const tenantName = localStorage.getItem('url_name')
      const returnQueryParam = this.$route.query.returnQuery
      const query = {}

      if (returnQueryParam) {
        try {
          const returnQuery = JSON.parse(returnQueryParam)
          Object.assign(query, returnQuery)
          // Also store in sessionStorage for browser back button support
          sessionStorage.setItem('jobHistoryReturnState', JSON.stringify(returnQuery))
        } catch (e) {
          console.error('Failed to parse returnQuery:', e)
        }
      }

      // If coming from dashboard, navigate to dashboard instead of job-history
      if (from === 'dashboard') {
        return {
          name: 'dashboard',
          params: { tenantName },
          query: query,
        }
      }

      // Default to job-history
      return {
        name: 'job-history',
        params: { tenantName },
        query: query,
      }
    },
    async handleCancel() {
      const hasModifiedFields = Object.values(this.filteredDocumentEntities).some((field) => field.isModified)
      // Check if multiple documents are selected
      const hasMultipleSelectedDocuments = this.selectedDocuments.length >= 1

      // Check if any document groups have been changed
      const hasChangedDocumentGroups = this.documents.some((group) => group.changed)

      if (hasModifiedFields || hasMultipleSelectedDocuments || hasChangedDocumentGroups) {
        this.showExtractionChangesModalNew = true
      } else {
        this.$router.push(this.getReturnRoute())
      }
    },
    async handleSave() {
      // Prevent multiple simultaneous save operations
      if (this.isSaving) {
        return
      }

      this.isSaving = true
      try {
        this.isSaveSuccessful = true 
        // Get only the document groups that have been changed
        const selectedGroups = this.documents.filter((group) => group.checked)

        // Validate that all required fields are selected for selected document groups
        const invalidGroups = selectedGroups.filter((group) => {
          // For Bedrock and textract mode, only validate document type and data
          if (this.isBedrock || this.isTextract) {
            return !group.tenant_document_type_id || !group.data || group.data.length === 0
          }
          // For non-Bedrock mode, validate all fields including category and department
          return !group.actual_category_id || !group.actual_department_id || !group.tenant_document_type_id || !group.data || group.data.length === 0
        })

        if (invalidGroups.length > 0) {
          // Provide context-appropriate error messages
          const errorMessage = this.isBedrock || this.isTextract ? 'Please ensure all document groups have a Document Type selected and contain at least one page.' : this.$t('view_document.messages.validation.classification_required')

          showToast({
            title: this.$t('view_document.messages.validation.error_title'),
            message: errorMessage,
            type: 'error',
          })
          return
        }

        // Create the payload array only from selected document groups
        const payload = selectedGroups.flatMap((documentGroup, groupIndex) => {
          return documentGroup.data.map((page, index) => {
            console.log('documentGroupdocumentGroup', documentGroup)
            const payloadItem = {
              id: page.id,
              tenant_document_type_id: documentGroup.tenant_document_type_id,
              page_number: index + 1,
            }

            // Only include result_document_id if mx_job_result_document_id is present
            if (documentGroup.mx_job_result_document_id) {
              payloadItem.result_document_id = Number(documentGroup.mx_job_result_document_id)
              payloadItem.group_id = documentGroup?.group_id
            } else {
              payloadItem.group_id = Number(groupIndex + 1)
            }

            // const isPageDragged = parseInt(page.id) !== parseInt(page.sourceImageId)
            // Only include mx_file_job_id if the page hasn't been dragged to a different group
            // if (page?.id !== undefined && page?.sourceImageId !== undefined && parseInt(page?.id) !== parseInt(page?.sourceImageId)) {
            // if ((page?.id !== undefined && page?.sourceImageId !== undefined && parseInt(page?.id) !== parseInt(page?.sourceImageId)) || page?.isDraggedNew !== false) {
            //   // if (page?.id !== undefined && page?.sourceImageId !== undefined && parseInt(page?.id) !== parseInt(page?.sourceImageId)) {
            //   if (page?.mx_job_result_document_id) {
            //     payloadItem.result_document_id = page?.mx_job_result_document_id
            //   }
            //   // }
            // } else {
            //   // payloadItem.mx_file_job_id = documentGroup?.mx_job_file_id
            // }

            return payloadItem
          })
        })
        const payload2 = selectedGroups.flatMap((documentGroup, groupIndex) => {
          return documentGroup.data.map((page, index) => {
            console.log('documentGroup.mx_job_result_document_id', documentGroup.mx_job_result_document_id)
            if (documentGroup.mx_job_result_document_id === 0 || documentGroup.mx_job_result_document_id === null) {
              const payloadItem = {
                id: page.id,
                tenant_document_type_id: documentGroup.tenant_document_type_id,
                page_number: index + 1,
              }

              // Only include result_document_id if mx_job_result_document_id is present
              if (documentGroup.mx_job_result_document_id) {
                payloadItem.result_document_id = Number(documentGroup.mx_job_result_document_id)
                payloadItem.group_id = documentGroup?.group_id
              } else {
                payloadItem.group_id = Number(groupIndex + 1)
              }

              // const isPageDragged = parseInt(page.id) !== parseInt(page.sourceImageId)
              // Only include mx_file_job_id if the page hasn't been dragged to a different group
              // if (page?.id !== undefined && page?.sourceImageId !== undefined && parseInt(page?.id) !== parseInt(page?.sourceImageId)) {
              // if ((page?.id !== undefined && page?.sourceImageId !== undefined && parseInt(page?.id) !== parseInt(page?.sourceImageId)) || page?.isDraggedNew !== false) {
              //   // if (page?.id !== undefined && page?.sourceImageId !== undefined && parseInt(page?.id) !== parseInt(page?.sourceImageId)) {
              //   if (page?.mx_job_result_document_id) {
              //     payloadItem.result_document_id = page?.mx_job_result_document_id
              //   }
              //   // }
              // } else {
              //   // payloadItem.mx_file_job_id = documentGroup?.mx_job_file_id
              // }

              return payloadItem
            } else {
              return null
            }
          })
        })

        if (payload.length === 0) {
          showToast({
            title: this.$t('view_document.messages.validation.no_changes_title'),
            message: this.$t('view_document.messages.validation.no_changes_message'),
            type: 'error',
          })
          return
        }
        if (payload2 && payload2.length > 0 && payload2.some((item) => item !== null)) {
          // Filter out null items before grouping
          const filteredPayload2 = payload2.filter((item) => item !== null)
          // Group payload2 by tenant_document_type_id
          const groupedPayload2 = filteredPayload2.reduce((acc, item) => {
            const key = item?.group_id || 'null'
            if (!acc[key]) {
              acc[key] = []
            }
            acc[key].push(item)
            return acc
          }, {})
          // console.log('groupedPayload2', groupedPayload2)
          // Call API for each group in parallel using Promise.all
          const groupKeys2 = Object.keys(groupedPayload2)
          const apiPromises2 = groupKeys2.map((key) => post('/v1/mx-file-page-textract-details/updateResultDocumentForNonMatchedDocs', groupedPayload2[key]))
          await Promise.all(apiPromises2)
        }

        // Filter out null items before grouping
        const filteredPayload = payload.filter((item) => item !== null)
        // Group payload by tenant_document_type_id
        const groupedPayload = filteredPayload.reduce((acc, item) => {
          const key = item.tenant_document_type_id || 'null'
          if (!acc[key]) {
            acc[key] = []
          }
          acc[key].push(item)
          return acc
        }, {})

        // Call API for each group in parallel using Promise.all
        const groupKeys = Object.keys(groupedPayload)
        const apiPromises = groupKeys.map((key) => put('/v1/mx-file-page-textract-details/bulk', groupedPayload[key]))
        await Promise.all(apiPromises)

        this.isSaveSuccessful = true // Set to true after successful save

        // Reset changed and checked flags for all documents
        this.documents = this.documents.map((group) => ({
          ...group,
          changed: false,
          checked: false,
          isModified: false,
          data: group.data.map((page) => ({
            ...page,
            page_number: page.page_number,
            isDragged: false,
            isModified: false,
            original_mx_job_file_id: null, // Reset the original job file ID
          })),
        }))

        this.selectedDocuments = []

        showToast({
          title: this.$t('view_document.messages.success.operation_successful'),
          message: this.$t('view_document.messages.success.documents_updated'),
          type: 'success',
        })

        this.fetchJobDetails()
        this.showStartExtractionButton = true
      } catch (error) {
        this.isSaveSuccessful = false // Set to false if save fails
        showToast({
          title: this.$t('view_document.messages.error.operation_failed'),
          message: this.$t('view_document.messages.error.update_failed'),
          type: 'error',
        })
      } finally {
        this.isSaving = false
      }
    },
    async handleSaveEntities() {
      // Prevent multiple simultaneous save operations
      if (this.isSavingEntities) {
        return
      }

      this.isSavingEntities = true
      try {
        // Create array to store all entity updates
        const entityUpdates = []

        // Loop through all document types in filteredDocumentEntities
        Object.values(this.filteredDocumentEntities).forEach((field) => {
          entityUpdates.push({
            id: field.id,
            value: field.value,
            is_manual: field.isModified,
          })
        })
        Object.values(this.filteredDocumentEntities).forEach((docFields) => {
          if (docFields && typeof docFields === 'object') {
            Object.values(docFields).forEach((field) => {
              if (field && typeof field === 'object') {
                field.isModified = false
              }
            })
          }
        })
        if (entityUpdates.length === 0) {
          showToast({
            title: this.$t('view_document.messages.info.title'),
            message: this.$t('view_document.messages.validation.no_changes_info'),
            type: 'info',
          })
          return
        }
// alert('entityUpdates')
        // Make API call to update entities
        const response = await put('/v1/mx-document-entities', entityUpdates)
       
        if (response?.status === 200) {
          // Fetch updated entities from API to get the latest is_manual flags
          const response2 = await get(`/v1/mx-document-entities`, {
            mx_job_id: this.$route.query.jobId,
            mx_job_result_document_id: this.selectedImageSrc.mx_job_result_document_id,
          })

          // Update documentEntitiesNew with the fresh data from API (includes is_manual: true)
          if (response2?.data && response2.data[this.selectedImageSrc.mx_job_result_document_id]) {
            const updatedFields = response2.data[this.selectedImageSrc.mx_job_result_document_id]
            const fileId = this.selectedImageSrc.mx_job_result_document_id
            
            // Create a new object structure to ensure Vue reactivity
            const updatedDocumentEntitiesNew = { ...this.documentEntitiesNew }
            const existingDocFields = this.documentEntitiesNew[fileId] || {}
            
            // Merge updated fields with existing fields, preserving all properties
            const mergedFields = {}
            Object.keys(existingDocFields).forEach((fieldId) => {
              if (updatedFields[fieldId]) {
                // Field exists in API response - use fresh data
                mergedFields[fieldId] = {
                  ...existingDocFields[fieldId],
                  ...updatedFields[fieldId],
                  isModified: false,
                }
                // Update original values
                const key = `${fileId}_${fieldId}`
                this.originalFieldValues[key] = updatedFields[fieldId].value
              } else {
                // Field doesn't exist in response - keep existing
                mergedFields[fieldId] = { ...existingDocFields[fieldId] }
              }
            })
            
            // Add any new fields from API response
            Object.keys(updatedFields).forEach((fieldId) => {
              if (!mergedFields[fieldId]) {
                mergedFields[fieldId] = {
                  ...updatedFields[fieldId],
                  isModified: false,
                }
                const key = `${fileId}_${fieldId}`
                this.originalFieldValues[key] = updatedFields[fieldId].value
              }
            })
            
            // Update documentEntitiesNew with new structure
            updatedDocumentEntitiesNew[fileId] = mergedFields
            this.documentEntitiesNew = updatedDocumentEntitiesNew
          }

          showToast({
            title: this.$t('view_document.messages.success.title'),
            message: this.$t('view_document.messages.success.entities_updated'),
            type: 'success',
          })
        } else {
          throw new Error('Failed to update entities')
        }
      } catch (error) {
        showToast({
          title: this.$t('view_document.messages.error.title'),
          message: this.$t('view_document.messages.error.entities_update_failed'),
          type: 'error',
        })
      } finally {
        this.isSavingEntities = false
      }
    },
    async handleStartWorkflow() {
      // Prevent multiple clicks
      if (this.isStartingWorkflow) {
        return
      }

      this.isStartingWorkflow = true
      try {
        const jobId = this.$route.query.jobId

        if (!jobId) {
          showToast({
            title: this.$t('view_document.messages.error.title'),
            message: this.$t('view_document.messages.validation.job_document_required'),
            type: 'error',
          })
          this.isStartingWorkflow = false
          return
        }

        this.lastAction = 'startWorkflow'
        const resultDocument = this.mainResponse?.result_document?.find((doc) => doc.id === Number(this.selectedImageSrc?.mx_job_result_document_id))
        if (resultDocument?.status === 'pending' || resultDocument?.status === 'in_progress') {
          this.isSendingToVasion = false
          showToast({
            title: this.$t('view_document.messages.error.title'),
            message: 'Please complete document extraction before starting workflow',
            type: 'error',
          })
          return
        }
        const mainNumber = Number(resultDocument.id)
        // Check if document is already sent to Vasion

        if (resultDocument.vasion_status === 'completed') {
          this.showVasionModal = true
          this.isStartingWorkflow = false
        } else {
          try {
            const jobId = this.$route.query.jobId

            const response = await post('/v1/vasion/save-specific-documents', {
              job_id: parseInt(jobId),
              result_doc_ids: [parseInt(mainNumber)],
              save_to_vasion: false,
            })

            if (response?.data?.code === 200) {
              showToast({
                title: this.$t('view_document.messages.success.title'),
                message: this.$t('view_document.messages.success.workflow_started'),
                type: 'success',
              })
              this.showVasionModal = false
              await this.fetchJobDetails()
              // Reload entities if extraction view is open
              if (this.isExtractionOpen && this.selectedImageSrc?.mx_job_result_document_id) {
                await this.fetchDocumentEntitiesForFile(this.selectedImageSrc.mx_job_result_document_id)
              }
              // Emit event to refresh data if needed
              this.$emit('refresh')
            }
            this.isStartingWorkflow = false
          } catch (error) {
            showToast({
              title: this.$t('view_document.messages.error.title'),
              message: error.response?.data?.message || this.$t('view_document.messages.error.operation_failed'),
              type: 'error',
            })
            this.showVasionModal = false
            this.isStartingWorkflow = false
          }
        }
      } catch (error) {
        showToast({
          title: this.$t('view_document.messages.error.title'),
          message: this.$t('view_document.messages.error.workflow_failed'),
          type: 'error',
        })
        this.isStartingWorkflow = false
      }
    },

    async handleStartExtraction() {
      try {
        this.isExtractionInProgress = true
        const jobId = this.$route.query.jobId

        if (!jobId) {
          showToast({
            title: this.$t('view_document.messages.error.title'),
            message: this.$t('view_document.messages.validation.job_required'),
            type: 'error',
          })
          return
        }

        showToast({
          title: this.$t('view_document.messages.success.title'),
          message: this.$t('view_document.messages.success.extraction_started'),
          type: 'success',
        })
        const response = await put(`/v1/mx-jobs/trigger/${jobId}`)
        if (response?.status === 200) {
          this.isExtractionInProgress = true
          this.showLoadingOverlay = true
          this.extractionProgress = 0

          // Start polling for progress
          this.extractionPollingInterval = setInterval(async () => {
            try {
              const progressResponse = await get(`/v1/mx-jobs/${jobId}`)
              if (progressResponse?.data) {
                const completedPercentage = parseInt(progressResponse?.data?.completed_percentage) || 0
                this.extractionProgress = completedPercentage

                if (completedPercentage >= 100) {
                  clearInterval(this.extractionPollingInterval)
                  this.isExtractionInProgress = false
                  this.showLoadingOverlay = false
                  this.extractionProgress = 0
                  await this.fetchJobDetails()

                  showToast({
                    title: this.$t('view_document.messages.success.title'),
                    message: this.$t('view_document.messages.success.extraction_completed'),
                    type: 'success',
                  })
                  this.showStartExtractionButton = false
                }
              }
            } catch (error) {
              clearInterval(this.extractionPollingInterval)
              this.isExtractionInProgress = false
              this.showLoadingOverlay = false
              this.extractionProgress = 0

              // showToast({
              //   title: 'Error',
              //   message: 'Failed to track extraction progress',
              //   type: 'error',
              // })
            }
          }, 2000) // Poll every 2 seconds
        }
      } catch (error) {
        this.isExtractionInProgress = false
        showToast({
          title: this.$t('view_document.messages.error.title'),
          message: this.$t('view_document.messages.error.extraction_failed'),
          type: 'error',
        })
      }
    },

    async handleSendToVasion(secondaryStatus) {
      // Prevent double-clicks by setting loading flag immediately
      if (this.isSendingToVasion) {
        return
      }

      this.isSendingToVasion = true

      try {
        const jobId = this.$route.query.jobId
        if (!jobId) {
          this.isSendingToVasion = false
          showToast({
            title: this.$t('view_document.messages.error.title'),
            message: this.$t('view_document.messages.validation.job_document_required'),
            type: 'error',
          })
          return
        }
        const resultDocument = this.mainResponse?.result_document?.find((doc) => doc.id === Number(this.selectedImageSrc?.mx_job_result_document_id))
        console.log('resultDocumentresultDocument', resultDocument)
        const mainNumber = Number(resultDocument.id)
        if (!resultDocument) {
          this.isSendingToVasion = false
          showToast({
            title: this.$t('view_document.messages.error.title'),
            message: this.$t('view_document.messages.validation.document_not_found'),
            type: 'error',
          })
          return
        }
        if (resultDocument?.status === 'pending' || resultDocument?.status === 'in_progress') {
          this.isSendingToVasion = false
          showToast({
            title: this.$t('view_document.messages.error.title'),
            message: 'Please complete document extraction before sending to Vasion',
            type: 'error',
          })
          return
        }
        this.lastAction = 'sendToVasion'
        if (resultDocument.vasion_status === 'completed') {
          this.isSendingToVasion = false
          this.showVasionModal = true
        } else {
          try {
            const saveToVasion = true
            const response = await post('/v1/vasion/save-specific-documents', {
              job_id: parseInt(jobId),
              result_doc_ids: [parseInt(mainNumber)],
              save_to_vasion: true,
              secondary_vasion_status: secondaryStatus === 'Approved' || this.selectedVasionStatus === 'Approved' ? '' : secondaryStatus || this.selectedVasionStatus || '',
            })
            if (response?.data?.code === 200) {
              showToast({
                title: this.$t('view_document.messages.success.title'),
                message: saveToVasion ? this.$t('view_document.messages.success.sent_to_vasion') : this.$t('view_document.messages.success.workflow_started'),
                type: 'success',
              })
              this.showVasionModal = false
              this.selectedVasionStatus = ''
              await this.fetchJobDetails()
              // Reload entities if extraction view is open
              if (this.isExtractionOpen && this.selectedImageSrc?.mx_job_result_document_id) {
                await this.fetchDocumentEntitiesForFile(this.selectedImageSrc.mx_job_result_document_id)
              }
              this.$emit('refresh')
            }
          } catch (error) {
            showToast({
              title: this.$t('view_document.messages.error.title'),
              message: error.response?.data?.message || this.$t('view_document.messages.error.operation_failed'),
              type: 'error',
            })
            this.showVasionModal = false
          } finally {
            this.isSendingToVasion = false
          }
        }
      } catch (error) {
        this.isSendingToVasion = false
        showToast({
          title: this.$t('view_document.messages.error.title'),
          message: this.$t('view_document.messages.error.vasion_failed'),
          type: 'error',
        })
      }
    },

    async confirmSendToVasion() {
      // Prevent multiple clicks
      if (this.isSendingToVasion) {
        return
      }

      try {
        this.isSendingToVasion = true
        const jobId = this.$route.query.jobId

        if (!jobId) {
          showToast({
            title: this.$t('view_document.messages.error.title'),
            message: this.$t('view_document.messages.validation.job_document_required'),
            type: 'error',
          })
          this.isSendingToVasion = false
          return
        }
        // Find the result document for the current document
        const resultDocument = this.mainResponse?.result_document?.find((doc) => doc.id === Number(this.selectedImageSrc?.mx_job_result_document_id))
        const mainNumber = Number(resultDocument.id)

        try {
          const jobId = this.$route.query.jobId
          const saveToVasion = true

          const response = await post('/v1/vasion/save-specific-documents', {
            job_id: parseInt(jobId),
            result_doc_ids: [parseInt(mainNumber)],
            save_to_vasion: this.lastAction === 'sendToVasion' ? true : false,
            secondary_vasion_status: this.selectedVasionStatus === 'Approved' ? '' : this.selectedVasionStatus || '',
          })

          if (response?.data?.code === 200) {
            showToast({
              title: this.$t('view_document.messages.success.title'),
              message: saveToVasion ? this.$t('view_document.messages.success.sent_to_vasion') : this.$t('view_document.messages.success.workflow_started'),
              type: 'success',
            })
            this.showVasionModal = false
            await this.fetchJobDetails()
            // Reload entities if extraction view is open
            if (this.isExtractionOpen && this.selectedImageSrc?.mx_job_result_document_id) {
              await this.fetchDocumentEntitiesForFile(this.selectedImageSrc.mx_job_result_document_id)
            }
            this.selectedVasionStatus = ''

            // Emit event to refresh data if needed
            this.$emit('refresh')
          }
        } catch (error) {
          showToast({
            title: 'Error',
            message: error.response?.data?.message || 'Operation failed',
            type: 'error',
          })
          this.showVasionModal = false
        }
      } catch (error) {
        showToast({
          title: this.$t('view_document.messages.error.title'),
          message: this.$t('view_document.messages.error.vasion_failed'),
          type: 'error',
        })
      }
      finally {
        this.isSendingToVasion = false
      }
    },

    async fetchDocumentTypes() {
      try {
        const userData = JSON.parse(localStorage.getItem('UserData'))
        const tenantId = userData?.tenant_id
        const response = await get(`/v1/tenant-document-types?page=1&pageSize=1000&tenantId=${tenantId}`)
        if (response?.data?.code === 200) {
          this.documentTypes = response.data.data.data.filter((type) => type.is_active === true)
        }
      } catch (error) {}
    },

    async fetchAllDocumentTypes() {
      try {
        const userData = JSON.parse(localStorage.getItem('UserData'))
        const tenantId = userData?.tenant_id
        const response = await get(`/v1/tenant-document-types?page=1&pageSize=1000&tenantId=${tenantId}`)
        if (response?.data?.code === 200) {
          this.documentTypes = response.data.data.data.filter((type) => type.is_active === true)
        }
      } catch (error) {
        showToast({
          title: this.$t('view_document.messages.error.title'),
          message: this.$t('view_document.messages.error.document_types_failed'),
          type: 'error',
        })
      }
    },
    async fetchCategories() {
      try {
        const userData = JSON.parse(localStorage.getItem('UserData'))
        const tenantId = userData?.tenant_id
        // const response = await get(`/v1/tenant-categories/${tenantId}`)
        const response = await get(`/v1/tenant-categories?page=1&pageSize=1000&tenantId=${tenantId}`)
        if (response?.data?.code === 200) {
          this.categories = response.data.data.data.filter((category) => category.is_active === true)
        }
      } catch (err) {
        showToast({
          title: this.$t('view_document.messages.error.title'),
          message: this.$t('view_document.messages.error.categories_failed'),
          type: 'error',
        })
      }
    },
    async fetchDepartments() {
      try {
        const userData = JSON.parse(localStorage.getItem('UserData'))
        const tenantId = userData?.tenant_id
        const response = await get(`/v1/tenant-departments?page=1&pageSize=1000&tenantId=${tenantId}`)
        // const userData = JSON.parse(localStorage.getItem('UserData'))
        // const tenantId = userData?.tenant_id
        // const response = await get(`/v1/tenant-categories/${tenantId}`)
        if (response?.data?.code === 200) {
          this.departments = response.data.data.data.filter((category) => category.is_active === true)
        }
      } catch (err) {
        showToast({
          title: this.$t('view_document.messages.error.title'),
          message: this.$t('view_document.messages.error.categories_failed'),
          type: 'error',
        })
      }
    },

    async fetchDepartmentsByCategory(categoryId) {
      try {
        const userData = JSON.parse(localStorage.getItem('UserData'))
        const tenantId = userData?.tenant_id

        // Use the correct API endpoint to fetch all departments for a category
        const response = await get(`/v1/tenant-departments?tenantId=${tenantId}&categoryId=${categoryId}&page=1&pageSize=1000`)

        if (response?.data?.code === 200) {
          this.departments = response.data.data.data || []

          // Log the document group's category_id for debugging
        }
      } catch (err) {
        showToast({
          title: this.$t('view_document.messages.error.title'),
          message: this.$t('view_document.messages.error.departments_failed'),
          type: 'error',
        })
      }
    },

    async fetchDocumentTypesByDepartment(departmentId) {
      // this.loading = true
      try {
        const userData = JSON.parse(localStorage.getItem('UserData'))
        const tenantId = userData?.tenant_id

        // const response = await get(
        //   `/v1/document-types/department/${departmentId}?tenant_id=${tenantId}`
        // )
        const response = await get(`tenant-document-types/by-department?${departmentId}?tenant_id=${tenantId}`)
        if (response?.data?.code === 200) {
          this.documentTypes = response.data.data.data
        }
      } catch (err) {
        showToast({
          title: this.$t('view_document.messages.error.title'),
          message: this.$t('view_document.messages.error.document_types_failed'),
          type: 'error',
        })
      } finally {
        // this.loading = false
      }
    },

    async handleCategoryChange(event, documentGroup) {
      const selectedCategoryId = Number(event.target.value)
      const selectedCategory = this.categories.find((cat) => Number(cat.category_id) === selectedCategoryId)
      if (selectedCategory) {
        // Update document group with new category values
        const updatedDocumentGroup = {
          ...documentGroup,
          category: selectedCategory.category_display_name || selectedCategory.name,
          category_id: selectedCategory.category_id,
          actual_category_name: selectedCategory.category_display_name || selectedCategory.name,
          actual_category_id: selectedCategory.category_id,
          departmentList: this.departments.filter((dept) => Number(dept.category_id) === selectedCategoryId),
          documentTypeList: [],
          changed: true, // Set changed flag to true
          checked: true, // Set checked flag to true
          split_document: false,
        }

        // Find the index of the document group in the documents array using unique identifier
        const docIndex = this.documents.findIndex((doc) => doc.mx_job_result_document_id === documentGroup.mx_job_result_document_id)

        if (docIndex !== -1) {
          // Update document in reactive way
          this.documents.splice(docIndex, 1, updatedDocumentGroup)
        } else {
        }

        await nextTick()
      } else {
      }
    },
    async handleDepartmentChange(event, documentGroup) {
      const selectedDepartmentId = Number(event.target.value)
      const selectedDepartment = this.departments.find((dept) => Number(dept.department_id) === selectedDepartmentId)
      if (selectedDepartment) {
        // Filter document types for the selected department
        const filteredDocumentTypes = this.documentTypes.filter((docType) => {
          docType.actual_department_id = docType.document_type?.department_id
          return Number(docType.department_id) === Number(selectedDepartmentId)
        })
        // Update document group with new department values
        const updatedDocumentGroup = {
          ...documentGroup,
          department: selectedDepartment.department_display_name || selectedDepartment.department_name,
          department_id: selectedDepartmentId,
          actual_department_name: selectedDepartment.department_display_name || selectedDepartment.department_name,
          actual_department_id: selectedDepartmentId,
          documentTypeList: filteredDocumentTypes,
          changed: true, // Set changed flag to true
          checked: true, // Set checked flag to true
        }

        // Find the index of the document group in the documents array using unique identifier
        const docIndex = this.documents.findIndex((doc) => doc.mx_job_result_document_id === documentGroup.mx_job_result_document_id)

        if (docIndex !== -1) {
          // Update document in reactive way
          this.documents.splice(docIndex, 1, updatedDocumentGroup)
        } else {
        }

        await nextTick()
      } else {
      }
    },

    async handleDocumentTypeChange(event, documentGroup, groupIndex) {
      const selectedDocumentTypeId = Number(event.target.value)

      const selectedDocumentType = documentGroup.documentTypeList.find((docType) => Number(docType.id) === selectedDocumentTypeId)

      if (selectedDocumentType) {
        // Store original values before update for reliable matching
        const originalTenantDocumentTypeId = documentGroup.tenant_document_type_id
        const originalMxJobResultDocumentId = documentGroup.mx_job_result_document_id
        const originalMxJobFileId = documentGroup.mx_job_file_id

        // Update document group with new document type values
        const updatedDocumentGroup = {
          ...documentGroup,
          title: selectedDocumentType.document_type_display_name,
          tenant_document_type: selectedDocumentType,
          tenant_document_type_id: selectedDocumentType.id,
          actual_document_type: selectedDocumentType.id,
          actual_document_type_name: selectedDocumentType.document_type_display_name,
          ml_confidence_level: selectedDocumentType.ml_confidence_level,
          page_count: selectedDocumentType.page_count,
          changed: true, // Set changed flag to true
          checked: true, // Set checked flag to true
        }

        // Find the index of the document group in the documents array using unique identifier
        // Use combination of mx_job_result_document_id and original tenant_document_type_id for reliable matching
        // Also check mx_job_file_id as fallback for split documents
        const docIndex = this.documents.findIndex((doc, index) => {
          console.log('doc.groupIndex', groupIndex, 'index', index)
          // const matchesResultDocId = doc.group_id === documentGroup?.group_id
          const isSame = groupIndex === index
          return isSame
        })

        if (docIndex !== -1) {
          // Update document in reactive way
          this.documents.splice(docIndex, 1, updatedDocumentGroup)
        } else {
        }

        await nextTick()
      }
    },

    // handleDocumentTypeChange(documentGroup, documentTypeId) {
    //   documentGroup.title = documentTypeId
    // },

    async handleSplitNewDocument() {
      // Ensure document types are loaded for the new document group
      if (this.isBedrock || this.isTextract) {
        // For Bedrock mode, fetch all document types if not already loaded
        if (this.documentTypes.length === 0) {
          await this.fetchAllDocumentTypes()
        }
      } else {
        // For non-Bedrock mode, ensure categories are loaded
        if (this.categories.length === 0) {
          await this.fetchCategories()
        }
      }

      // Create a new blank document group with the same structure
      const newDocumentGroup = {
        title: '',
        category: '',
        department: '',
        data: [],
        tenant_document_type: {
          id: null,
          document_type: {
            ml_confidence_level: 0,
          },
        },
        category_id: null,
        department_id: null,
        tenant_document_type_id: null,
        actual_document_type: null,
        actual_document_type_name: '',
        actual_category_name: '',
        actual_category_id: null,
        actual_department_name: '',
        actual_department_id: null,
        document_name: 'New Document',
        document_name_full: 'New Document',
        ml_confidence_level: 0,
        categoryList: this.categories,
        departmentList: this.departments,
        documentTypeList: this.isBedrock || this.isTextract ? this.documentTypes : [], // For Bedrock and textract, use all document types
        mx_job_result_document_id: null,
        mx_job_file_id: this.mainResponse?.job_files?.[0]?.id || null,
        isNewlyCreated: true, // Add this flag
        split_document: true,
        vasion_status: 'pending',
        group_id: null,
      }
      // Find the current document group based on the currently selected image
      let insertIndex = this.documents.length // Default to end if current document not found
      if (this.selectedImageSrc) {
        const currentDocumentGroup = this.documents.find((group) => group.data.some((page) => page.id === this.selectedImageSrc.id))
        if (currentDocumentGroup) {
          const currentIndex = this.documents.findIndex((group) => group === currentDocumentGroup)
          if (currentIndex !== -1) {
            insertIndex = currentIndex + 1 // Insert right after the current document
          }
        }
      }

      // Insert the new group at the calculated position
      this.documents.splice(insertIndex, 0, newDocumentGroup)

      // Don't automatically check the checkbox for the new document
      // Only check if there are actual changes
      if (!this.selectedDocuments.includes(newDocumentGroup.mx_job_file_id)) {
        this.selectedDocuments = [...this.selectedDocuments]
      }

      // Show success toast
      showToast({
        title: this.$t('view_document.messages.success.title'),
        message: this.$t('view_document.messages.success.document_group_created'),
        type: 'success',
      })
    },

    navigatePage(direction) {
      if (!this.selectedImageSrc) return

      // Find the current document group
      const currentGroup = this.sortedDocumentGroups.find((group) => group.data.some((page) => page.id === this.selectedImageSrc.id))
      const currentIndex = this.sortedDocumentGroups.findIndex((group) => group === currentGroup)

      if (!currentGroup) return

      // const currentIndex = currentGroup.data.findIndex(
      //   (page) => page.id === this.selectedImageSrc.id
      // )

      if (direction === 'prev') {
        if (currentIndex > 0) {
          this.setSelectedImage(this.sortedDocumentGroups[currentIndex - 1]?.data[0])
          this.currentPageIndex = currentIndex - 1
        }
      } else if (direction === 'next') {
        if (currentIndex < this.sortedDocumentGroups?.length - 1) {
          this.setSelectedImage(this.sortedDocumentGroups[currentIndex + 1]?.data[0])
          this.currentPageIndex = currentIndex + 1
        }
      } else {
      }

      this.totalPages = currentGroup.data.length
    },

    navigateInnerPage(direction) {
      if (!this.selectedImageSrc) return
      const currentGroup = this.sortedDocumentGroups.find((group) => group.data.some((page) => page.id === this.selectedImageSrc.id))
      if (!currentGroup) return

      const currentGroupIndex = this.sortedDocumentGroups.findIndex((group) => group === currentGroup)
      const currentIndex = currentGroup.data.findIndex((page) => page.id === this.selectedImageSrc.id)

      if (direction === 'prev') {
        if (currentIndex > 0) {
          // Navigate to previous page within the same document group
          this.setSelectedImage(currentGroup?.data?.[currentIndex - 1])
        } else if (currentGroupIndex === 0 && currentIndex === 0) {
          // We're on the first page of the first document group, navigate back to JobHistory
          // Use handleCancel to check for unsaved changes and navigate back with state preservation
          this.handleCancel()
        } else if (currentGroupIndex > 0) {
          // Navigate to the last page of the previous document group
          const prevGroup = this.sortedDocumentGroups[currentGroupIndex - 1]
          if (prevGroup && prevGroup.data.length > 0) {
            this.setSelectedImage(prevGroup.data[prevGroup.data.length - 1])
          }
        }
      } else if (direction === 'next') {
        if (Number(currentIndex) < Number(currentGroup?.data?.length) - 1) {
          this.setSelectedImage(currentGroup?.data?.[currentIndex + 1])
        }
      } else {
      }
    },

    toggleExpand() {
      this.isExpanded = !this.isExpanded
      const firstDiv = document.querySelector('.viewDocumentFirstDiv')
      const documentContainer = document.querySelector('.documentViewContainer')

      if (this.isExpanded) {
        firstDiv.style.display = 'none'
        documentContainer.style.marginLeft = '0'
        documentContainer.style.width = '100%'
      } else {
        firstDiv.style.display = 'block'
        documentContainer.style.marginLeft = '23px'
        documentContainer.style.width = ''
      }

      // Force recalculation of bounding boxes after layout change
      this.$nextTick(() => {
        // Add a longer delay to ensure DOM has fully updated
        setTimeout(() => {
          // If there are selected boundaries, force recalculation
          if (this.mainTextData && this.mainTextData.length > 0 && this.$refs.imageHighlighter) {
            // Force the ImageHighlighter to recalculate bounding box positions
            this.$refs.imageHighlighter.forceRecalculate()
          }
        }, 200) // Increased delay to ensure layout is complete
      })
    },
    // Add this new method
    hasDocumentChanges(documentGroup) {
      // Get the original document from mainResponse
      const originalDocument = this.mainResponse?.file_page_textract_details?.find((doc) => doc.id === documentGroup.data[0]?.id)

      if (!originalDocument) return false

      // Check if document type has changed
      const hasTypeChange = documentGroup.tenant_document_type_id !== originalDocument.tenant_document_type_id

      // Check if category has changed
      const hasCategoryChange = documentGroup.actual_category_id !== originalDocument.tenant_document_type?.category?.id

      // Check if department has changed
      const hasDepartmentChange = documentGroup.actual_department_id !== originalDocument.tenant_document_type?.department?.id

      // Check if pages have been reordered or moved
      const hasPageChanges = documentGroup.data.some((page) => {
        const originalPage = this.mainResponse?.file_page_textract_details?.find((p) => p.id === page.id)
        return originalPage && page.page_number !== originalPage.page_number
      })

      // Check if pages have been moved to other documents
      const hasPagesMoved = this.mainResponse?.file_page_textract_details?.some((originalPage) => {
        // If the original page belongs to this document group
        if (originalPage.mx_job_file_id === documentGroup.mx_job_file_id) {
          // Check if the page is still in this document group
          const pageStillExists = documentGroup.data.some((currentPage) => currentPage.id === originalPage.id)
          return !pageStillExists
        }
        return false
      })

      const hasChanges = hasTypeChange || hasCategoryChange || hasDepartmentChange || hasPageChanges || hasPagesMoved

      // Update the changed and checked flags
      // if (hasChanges) {
      //   documentGroup.changed = true
      //   documentGroup.checked = true
      //   // Add to selected documents if not already included
      //   if (!this.selectedDocuments.includes(documentGroup.mx_job_file_id)) {
      //     this.selectedDocuments.push(documentGroup.mx_job_file_id)
      //   }
      // }

      return hasChanges
    },
    toggleDocumentSelection(documentGroup) {
      documentGroup.checked = !documentGroup.checked
      const index = this.selectedDocuments.indexOf(documentGroup.mx_job_file_id)
      if (index === -1 && documentGroup.checked) {
        this.selectedDocuments.push(documentGroup.mx_job_file_id)
      } else if (index !== -1 && !documentGroup.checked) {
        this.selectedDocuments.splice(index, 1)
      }
    },
    selectAllChangedDocuments(event) {
      const isChecked = event.target.checked
      // Create a new array to trigger reactivity
      const updatedDocuments = this.sortedDocumentGroups.map((documentGroup) => {
        if (documentGroup.changed && documentGroup.checked !== isChecked) {
          return {
            ...documentGroup,
            checked: isChecked,
          }
        }
        return documentGroup
      })
      // Update the documents array to trigger reactivity
      this.documents = updatedDocuments

      // Update selectedDocuments array
      if (isChecked) {
        this.selectedDocuments = updatedDocuments.filter((group) => group.changed).map((group) => group.mx_job_file_id)
      } else {
        this.selectedDocuments = []
      }
    },
    checkFieldModification(field, docId) {
      const key = `${docId}_${field.id}`
      const originalValue = this.originalFieldValues[key]
      field.isModified = field.value !== originalValue
    },
    handleExtractionChangesConfirm() {
      // Create new object references to ensure Vue reactivity
      const updatedDocumentEntitiesNew = { ...this.documentEntitiesNew }
      Object.keys(updatedDocumentEntitiesNew).forEach((docId) => {
        const docFields = updatedDocumentEntitiesNew[docId]
        if (docFields && typeof docFields === 'object') {
          const updatedDocFields = { ...docFields }
          Object.keys(updatedDocFields).forEach((fieldId) => {
            const field = updatedDocFields[fieldId]
            if (field && typeof field === 'object') {
              // Revert field value to original value
              const key = `${docId}_${fieldId}`
              const originalValue = this.originalFieldValues[key]
              updatedDocFields[fieldId] = {
                ...field,
                value: originalValue !== undefined ? originalValue : field.value,
                isModified: false,
              }
            }
          })
          updatedDocumentEntitiesNew[docId] = updatedDocFields
        }
      })
      this.documentEntitiesNew = updatedDocumentEntitiesNew

      // Update sortedDocumentGroups with new references and revert classification values
      const updatedSortedGroups = this.sortedDocumentGroups.map((group) => {
        console.log('groupgroup_idupdatedSortedGroups', group?.group_id,group)
        const originalValues = this.originalClassificationValues[group.mx_job_file_id]
        return {
          ...group,
          changed: false, // Reset group-level changed flag
          checked: false, // Reset group-level checked flag
          // Revert classification values to original state
          category_id: originalValues?.category_id || group.category_id,
          actual_category_id: originalValues?.actual_category_id || group.actual_category_id,
          department_id: originalValues?.department_id || group.department_id,
          actual_department_id: originalValues?.actual_department_id || group.actual_department_id,
          tenant_document_type_id: originalValues?.tenant_document_type_id || group.tenant_document_type_id,
          actual_document_type: originalValues?.actual_document_type || group.actual_document_type,
          actual_document_type_name: originalValues?.actual_document_type_name || group.actual_document_type_name,
          group_id: group?.group_id || group.group_id,
          data: group.data.map((item) => ({
            ...item,
            isModified: false,
            changed: false,
            checked: false,
          })),
        }
      })
      this.sortedDocumentGroups = updatedSortedGroups

      // Update this.documents array to ensure consistency and revert classification values
      this.documents = this.documents.map((group) => {
        const originalValues = this.originalClassificationValues[group.mx_job_file_id]
        return {
          ...group,
          changed: false,
          checked: false,
          // Revert classification values to original state
          category_id: originalValues?.category_id || group.category_id,
          actual_category_id: originalValues?.actual_category_id || group.actual_category_id,
          department_id: originalValues?.department_id || group.department_id,
          actual_department_id: originalValues?.actual_department_id || group.actual_department_id,
          tenant_document_type_id: originalValues?.tenant_document_type_id || group.tenant_document_type_id,
          actual_document_type: originalValues?.actual_document_type || group.actual_document_type,
          actual_document_type_name: originalValues?.actual_document_type_name || group.actual_document_type_name,
          group_id: originalValues?.group_id || group.group_id,
        }
      })

      // Clear selected documents
      this.selectedDocuments = []

      this.setMainTextDataToNull()

      // Handle pending navigation
      if (this.pendingDocumentNavigationIndex !== null) {
        // Navigate to the pending document without changing tabs
        const selectedIdx = this.pendingDocumentNavigationIndex - 1 // 0-based
        const group = this.sortedDocumentGroups[selectedIdx]
        if (group && group.data.length > 0) {
          this.setSelectedImage(group.data[0])
          // Add delay before scrolling
          setTimeout(() => {
            const element = document.querySelector('.doc-classification-card-active')
            if (element) {
              element.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
              })
            }
          }, 100)
        }
        this.pendingDocumentNavigationIndex = null
      } else if (this.pendingExtractionValue !== null) {
        // Switch tabs
        this.isExtractionOpen = this.pendingExtractionValue
        // If opening extraction screen, fetch entities for the selected file if not already loaded
        if (this.pendingExtractionValue === true && this.selectedImageSrc?.mx_job_result_document_id) {
          this.fetchDocumentEntitiesForFile(this.selectedImageSrc.mx_job_result_document_id)
        }
        this.pendingExtractionValue = null
      }

      this.showExtractionChangesModal = false
    },
    handleExtractionChangesConfirmNew() {
      // Create new object references to ensure Vue reactivity
      const updatedDocumentEntitiesNew = { ...this.documentEntitiesNew }
      Object.keys(updatedDocumentEntitiesNew).forEach((docId) => {
        const docFields = updatedDocumentEntitiesNew[docId]
        if (docFields && typeof docFields === 'object') {
          const updatedDocFields = { ...docFields }
          Object.keys(updatedDocFields).forEach((fieldId) => {
            const field = updatedDocFields[fieldId]
            if (field && typeof field === 'object') {
              // Revert field value to original value
              const key = `${docId}_${fieldId}`
              const originalValue = this.originalFieldValues[key]
              updatedDocFields[fieldId] = {
                ...field,
                value: originalValue !== undefined ? originalValue : field.value,
                isModified: false,
              }
            }
          })
          updatedDocumentEntitiesNew[docId] = updatedDocFields
        }
      })
      this.documentEntitiesNew = updatedDocumentEntitiesNew

      // Update sortedDocumentGroups with new references and revert classification values
      const updatedSortedGroups = this.sortedDocumentGroups.map((group) => {
        const originalValues = this.originalClassificationValues[group.mx_job_file_id]
        return {
          ...group,
          changed: false, // Reset group-level changed flag
          checked: false, // Reset group-level checked flag
          // Revert classification values to original state
          category_id: originalValues?.category_id || group.category_id,
          actual_category_id: originalValues?.actual_category_id || group.actual_category_id,
          department_id: originalValues?.department_id || group.department_id,
          actual_department_id: originalValues?.actual_department_id || group.actual_department_id,
          tenant_document_type_id: originalValues?.tenant_document_type_id || group.tenant_document_type_id,
          actual_document_type: originalValues?.actual_document_type || group.actual_document_type,
          actual_document_type_name: originalValues?.actual_document_type_name || group.actual_document_type_name,
          group_id: originalValues?.group_id || group.group_id,
          data: group.data.map((item) => ({
            ...item,
            isModified: false,
            changed: false,
            checked: false,
          })),
        }
      })
      this.sortedDocumentGroups = updatedSortedGroups

      // Update this.documents array to ensure consistency and revert classification values
      this.documents = this.documents.map((group) => {
        const originalValues = this.originalClassificationValues[group.mx_job_file_id]
        return {
          ...group,
          changed: false,
          checked: false,
          // Revert classification values to original state
          category_id: originalValues?.category_id || group.category_id,
          actual_category_id: originalValues?.actual_category_id || group.actual_category_id,
          department_id: originalValues?.department_id || group.department_id,
          actual_department_id: originalValues?.actual_department_id || group.actual_department_id,
          tenant_document_type_id: originalValues?.tenant_document_type_id || group.tenant_document_type_id,
          actual_document_type: originalValues?.actual_document_type || group.actual_document_type,
          actual_document_type_name: originalValues?.actual_document_type_name || group.actual_document_type_name,
          group_id: originalValues?.group_id || group.group_id,
        }
      })

      // Clear selected documents
      this.selectedDocuments = []

      this.setMainTextDataToNull()
      this.isExtractionOpen = this.pendingExtractionValue
      this.showExtractionChangesModalNew = false
      this.pendingExtractionValue = null

      this.$router.push(this.getReturnRoute())
    },
    handleExtractionChangesClose() {
      this.showExtractionChangesModal = false
      this.pendingExtractionValue = null
      // If user cancels document navigation, restore the dropdown to current selection
      if (this.pendingDocumentNavigationIndex !== null) {
        // Restore to current selected document group index
        this.selectedDocumentGroupIndex = this.sortedDocumentGroups.findIndex((group) => group.mx_job_file_id === this.selectedImageSrc?.mx_job_file_id) + 1 || this.selectedDocumentGroupIndex
        this.pendingDocumentNavigationIndex = null
      }
    },
    handleExtractionChangesCloseNew() {
      this.showExtractionChangesModalNew = false
      this.pendingExtractionValue = null
      this.pendingDocumentNavigationIndex = null
    },
    handleDocumentGroupSelect(documentGroup) {
      // Find the index of the clicked group in sortedDocumentGroups
      const groupIndex = this.sortedDocumentGroups.indexOf(documentGroup)
      if (groupIndex !== -1) {
        this.selectedDocumentGroupIndex = groupIndex + 1 // 1-based index
        this.selectedDocumentGroupId = documentGroup.mx_job_file_id // if you want to track the id as well
      }
    },
    handleDocumentGroupSelectNew(documentGroup) {
      // Find the index of the clicked group in sortedDocumentGroups
      const groupIndex = this.sortedDocumentGroups.indexOf(documentGroup)
      if (groupIndex !== -1) {
        this.selectedDocumentGroupIndex = groupIndex + 1 // 1-based index
        this.selectedDocumentGroupId = documentGroup.mx_job_file_id // if you want to track the id as well
      }
      if (documentGroup?.data) {
        this.setSelectedImage(documentGroup.data[0])
      }
    },
    handleBeforeUnload(e) {
      const hasModifiedFields = Object.values(this.filteredDocumentEntities).some((field) => field.isModified)
      const hasMultipleSelectedDocuments = this.selectedDocuments.length >= 1
      const hasChangedDocumentGroups = this.documents.some((group) => group.changed)

      if (hasModifiedFields || hasMultipleSelectedDocuments || hasChangedDocumentGroups) {
        // Standard way to show confirmation dialog
        e.preventDefault()
        e.returnValue = ''
      }
    },
    handleViewJobHistory() {
      this.$router.push(this.getReturnRoute())
    },
    handleZoomIn() {
      if (this.$refs.imageHighlighter) {
        this.$refs.imageHighlighter.zoomIn()
      }
    },
    handleZoomOut() {
      if (this.$refs.imageHighlighter) {
        this.$refs.imageHighlighter.zoomOut()
      }
    },
    handleResetZoom() {
      if (this.$refs.imageHighlighter) {
        this.$refs.imageHighlighter.resetZoom()
      }
    },
    handleRotate() {
      if (this.$refs.imageHighlighter && this.$refs.imageHighlighter.rotateImage) {
        this.$refs.imageHighlighter.rotateImage()
      }
    },
    async handlePrintCurrentDocument() {
      try {
        const currentDocumentGroup = this.getCurrentDocumentGroup()
        if (!currentDocumentGroup) {
          showToast({
            title: this.$t('view_document.messages.error.title'),
            message: this.$t('view_document.messages.error.print_failed'),
            type: 'error',
          })
          return
        }

        // showToast({
        //   title: 'Opening Print Dialog',
        //   message: 'Please wait while we prepare the document for printing...',
        //   type: 'info',
        // })

        await printDocumentGroup(currentDocumentGroup)
        try {
          await this.logDocumentAudit(currentDocumentGroup.mx_job_result_document_id, 'PRINT_DOCUMENT')
        } catch (auditError) {
          // Don't show error to user for audit logging failure
        }
        // showToast({
        //   title: 'Print Dialog Opened',
        //   message: 'Print dialog has been opened in a new window',
        //   type: 'success',
        // })
      } catch (error) {
        showToast({
          title: this.$t('view_document.messages.error.title'),
          message: this.$t('view_document.messages.error.print_dialog_failed'),
          type: 'error',
        })
      }
    },
    async logDocumentAudit(resultDocumentId, actionType) {
      try {
        const response = await put(`/v1/mx_audit_report_log?result_document_id=${resultDocumentId}&action_type=${actionType}`)

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }

        const result = await response.json()
        return result
      } catch (error) {
        throw error
      }
    },
    async logJobAudit(jobId, actionType) {
      try {
        await put(`/v1/mx_audit_report_log?job_id=${jobId}&action_type=${actionType}`)
      } catch (error) {
        throw error
      }
    },
    async handlePrintAllDocuments() {
      try {
        if (!this.sortedDocumentGroups || this.sortedDocumentGroups.length === 0) {
          showToast({
            title: this.$t('view_document.messages.error.title'),
            message: this.$t('view_document.messages.error.no_documents_print'),
            type: 'error',
          })
          return
        }

        showToast({
          title: this.$t('view_document.messages.info.print_preparing'),
          message: this.$t('view_document.messages.info.print_all_preparing'),
          type: 'info',
        })

        await printAllDocuments(this.sortedDocumentGroups)

        showToast({
          title: this.$t('view_document.messages.success.title'),
          message: this.$t('view_document.messages.success.print_dialog_opened'),
          type: 'success',
        })
      } catch (error) {
        showToast({
          title: this.$t('view_document.messages.error.title'),
          message: this.$t('view_document.messages.error.print_all_failed'),
          type: 'error',
        })
      }
    },
    removeDocumentGroup(groupIndex) {
      if (this.documents[groupIndex]?.data?.length === 0) {
        // Remove the empty document group from the array
        this.documents.splice(groupIndex, 1)

        showToast({
          title: this.$t('view_document.messages.success.title'),
          message: this.$t('view_document.messages.success.empty_group_removed'),
          type: 'success',
        })
      }
    },
    getFieldConfidence(field) {
      if (!field || !field.mx_file_page_textract_detail_id) return 0

      const textractDetail = this.mainResponse?.file_page_textract_details?.find((item) => item.id === field.mx_file_page_textract_detail_id)
      if (!textractDetail || !textractDetail.bounding_box) return 0

      try {
        const boundingBoxes = JSON.parse(textractDetail.bounding_box)
        const matchingBox = boundingBoxes.find((box) => box.Text?.trim() === field.value?.trim())
        const confidence = Number(matchingBox?.Confidence || 0)
        return confidence
      } catch (error) {
        return 0
      }
    },
    calculateDocumentGroupConfidence(documentGroup) {
      if (!documentGroup?.data?.length) return 0

      // Calculate total confidence score
      const totalScore = documentGroup.data.reduce((acc, data) => {
        return acc + (data?.score * 100 || 0)
      }, 0)

      // Calculate average confidence
      const averageConfidence = Number(totalScore / documentGroup.data.length).toFixed(2)

      // Get ML confidence level threshold
      const mlConfidenceLevel = Number(documentGroup?.ml_confidence_level)

      return {
        averageConfidence,
        meetsThreshold: Number(averageConfidence) >= mlConfidenceLevel,
        mlConfidenceLevel,
      }
    },
    handleHeaderDocumentChange(event) {
      const selectedId = Number(event.target.value)
      this.selectedDocumentId = selectedId
      // The watcher will handle updating the selected image and page
    },
    handleHeaderPageChange(event) {
      const hasModifiedFields = Object.values(this.filteredDocumentEntities).some((field) => field.isModified)

      if (hasModifiedFields) {
        // Store the pending document navigation index
        this.pendingDocumentNavigationIndex = Number(event.target.value)
        this.showExtractionChangesModal = true
      } else {
        const selectedIdx = Number(event.target.value) - 1 // 0-based
        const group = this.sortedDocumentGroups[selectedIdx]
        if (group && group.data.length > 0) {
          this.setSelectedImage(group.data[0])
          // Add delay before scrolling
          setTimeout(() => {
            const element = document.querySelector('.doc-classification-card-active')
            if (element) {
              element.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
              })
            }
          }, 100) // Small delay to ensure DOM is updated
        }
      }
    },
    getFieldVasionStatus() {
      const mx_job_result_document_id = this.selectedImageSrc?.mx_job_result_document_id
      if (!mx_job_result_document_id) return null
      const documentGroup = this.sortedDocumentGroups.find((doc) => doc.mx_job_result_document_id === mx_job_result_document_id)
      return documentGroup?.vasion_status
    },
    getCurrentDocumentGroup() {
      const mx_job_result_document_id = this.selectedImageSrc?.mx_job_result_document_id
      if (!mx_job_result_document_id) return null
      const documentGroup = this.sortedDocumentGroups.find((doc) => doc.mx_job_result_document_id === mx_job_result_document_id)
      return documentGroup
    },
    getCurrentDocumentTypeData() {
      const currentDocumentTypeid = this.getCurrentDocumentGroup()?.tenant_document_type_id
      if (!currentDocumentTypeid) return null
      if (!this.documentTypes) return null
      const currentDocumentType = this.documentTypes.find((doc) => doc.id === currentDocumentTypeid)
      return currentDocumentType
    },
    selectVasionStatus(status) {
      this.selectedVasionStatus = status
      this.showVasionDropdown = false
      this.handleSendToVasion(status)
    },
    goToPrevDocumentGroup() {
      this.mainTextData = null
      if (this.selectedDocumentGroupIndex > 1) {
        this.selectedDocumentGroupIndex--
        this.handleHeaderPageChange({ target: { value: this.selectedDocumentGroupIndex } })
      }
    },
    goToNextDocumentGroup() {
      this.mainTextData = null
      if (this.selectedDocumentGroupIndex < this.sortedDocumentGroups.length) {
        this.selectedDocumentGroupIndex++
        this.handleHeaderPageChange({ target: { value: this.selectedDocumentGroupIndex } })
      }
    },
    toggleMagnifier() {
      this.$refs.imageHighlighter.resetZoom()
      this.magnifierEnabled = !this.magnifierEnabled
    },
    handleMouseDownDisableMagnifier() {
      if (this.magnifierEnabled) {
        this.magnifierEnabled = false
      }
    },
    handleTabNavigation(event, currentIndex) {
      // Only handle Tab and Shift+Tab keys
      if (event.key !== 'Tab') {
        return
      }

      // Get all active document fields
      const activeFields = this.activeDocumentFields(this.filteredDocumentEntities)

      if (!activeFields || activeFields.length === 0) {
        return
      }

      // Prevent default tab behavior
      event.preventDefault()

      let nextIndex
      if (event.shiftKey) {
        // Shift+Tab - go to previous field
        nextIndex = currentIndex > 0 ? currentIndex - 1 : activeFields.length - 1
      } else {
        // Tab - go to next field
        nextIndex = currentIndex < activeFields.length - 1 ? currentIndex + 1 : 0
      }

      // Get the next field and focus its input
      const nextField = activeFields[nextIndex][1] // activeFields is array of [key, field] tuples
      if (nextField) {
        const nextInput = document.getElementById(`input-${nextField.id}`)
        if (nextInput) {
          nextInput.focus()
        }
      }
    },
    // Line Items Methods
    async fetchLineItems(payload) {
      try {
        // this payload is correct do not remove the payload
        const response = await get(`/v1/line-items`, payload)
        console.log('[fetchLineItems] API Response:', response)
        if (response?.data && Array.isArray(response.data)) {
          console.log('[fetchLineItems] Calling convertLineItemsToTable with:', response.data)
          const tables = convertLineItemsToTable(response.data)
          console.log('[fetchLineItems] Converted tables:', tables)
          
          this.lineItemTables = tables
          this.hasLineItems = tables.length > 0
          console.log('[fetchLineItems] Set lineItemTables with', tables.length, 'table(s), hasLineItems:', this.hasLineItems)
        } else {
          console.warn('[fetchLineItems] Response.data is not an array:', response?.data)
          this.lineItemTables = []
          this.hasLineItems = false
        }
      } catch (error) {
        console.error('[fetchLineItems] Error fetching line items:', error)
        this.lineItemTables = []
        this.hasLineItems = false
      }
    },
    highlightGeometryOnImage(geometry) {
      // Handle geometry highlighting from LineItemsTable
      if (geometry) {
        console.log('[highlightGeometryOnImage] Received geometry:', geometry)
        // Format the geometry data for mainTextData which is used by ImageHighlighter
        const boundingBox = {
          Width: geometry.BoundingBox?.Width || 0,
          Height: geometry.BoundingBox?.Height || 0,
          Left: geometry.BoundingBox?.Left || 0,
          Top: geometry.BoundingBox?.Top || 0,
        }
        
        // Set mainTextData which is reactive and bound to ImageHighlighter
        this.mainTextData = [
          {
            BoundingBox: boundingBox,
            Text: 'Line Item Field',
            Confidence: 100,
          },
        ]
        console.log('[highlightGeometryOnImage] Set mainTextData:', this.mainTextData)
      }
    },
    handleLineItemsUpdated(responseData) {
      // Handle when line items are updated
      console.log('[handleLineItemsUpdated] Line items updated, refreshing data:', responseData);
      // Refresh line items to show latest data from server
      if (this.selectedImageSrc?.mx_job_result_document_id) {
        const payload =  {
          mx_job_id: this.$route.query.jobId,
          mx_job_result_document_id: this.selectedImageSrc?.mx_job_result_document_id,
        }
        this.fetchLineItems(payload);
      }
    },
    handleLineItemsSuccess(message) {
      showToast({
        title: this.$t('view_document.messages.success.title'),
        message: message || this.$t('view_document.messages.success.line_items_updated'),
        type: 'success',
      })
    },
    handleLineItemsError(errorMessage) {
      showToast({
        title: this.$t('view_document.messages.error.title'),
        message: errorMessage || this.$t('view_document.messages.error.line_items_update_failed'),
        type: 'error',
      })
    },
    handleDelete(documentGroup, groupIndex) {
      this.documentToDelete = documentGroup
      this.groupIndexToDelete = groupIndex
      this.showDeleteConfirmModal = true
    },
    handleDeleteConfirmClose() {
      this.showDeleteConfirmModal = false
      this.documentToDelete = null
      this.groupIndexToDelete = null
    },
    async confirmDelete() {
      if (!this.documentToDelete || this.groupIndexToDelete === null) {
        return
      }
      
      try {
        const deletedGroupId = this.documentToDelete.mx_job_result_document_id
        const indexToDelete = this.groupIndexToDelete
        
        // Call API to delete the document
        const response = await del(`/v1/mx-file-page-textract-details/delete-by-mx-job-result-document-id/${deletedGroupId}`)
        
        if (response.status === 204 || response.data?.code === 204) {
          // Create a new array without the deleted document to ensure Vue reactivity
          const updatedDocuments = this.documents.filter((doc, idx) => idx !== indexToDelete)
          
          // Update documents with new reference for proper Vue reactivity
          this.documents = updatedDocuments
          
          showToast({
            title: this.$t('view_document.messages.success.title') || 'Success',
            message: this.$t('view_document.messages.success.document_deleted') || 'Document deleted successfully',
            type: 'success',
          })
          
          // Close the modal and clear deletion references
          this.showDeleteConfirmModal = false
          this.documentToDelete = null
          this.groupIndexToDelete = null
          
          // Reset selected image if the deleted document was selected
          if (this.selectedImageSrc?.mx_job_result_document_id === deletedGroupId) {
            this.selectedImageSrc = null
          }
          
          // Ensure DOM updates with nextTick
          await this.$nextTick()
          
          // If there are remaining documents, select the first one
          if (this.documents.length > 0) {
            const firstGroup = this.documents[0]
            if (firstGroup.data && firstGroup.data.length > 0) {
              this.setSelectedImage(firstGroup.data[0])
              
              // Scroll to the first remaining document
              await this.$nextTick()
              const element = document.querySelector('.doc-classification-card')
              if (element) {
                element.scrollIntoView({
                  behavior: 'smooth',
                  block: 'center',
                })
              }
            }
          } else {
            // No documents left
            this.selectedImageSrc = null
            this.mainTextData = null
          }
        } else {
          showToast({
            title: this.$t('view_document.messages.error.title') || 'Error',
            message: this.$t('view_document.messages.error.delete_failed') || 'Failed to delete document',
            type: 'error',
          })
        }
      } catch (error) {
        console.error('Error deleting document:', error)
        showToast({
          title: this.$t('view_document.messages.error.title') || 'Error',
          message: error?.response?.data?.message || this.$t('view_document.messages.error.delete_failed') || 'Failed to delete document',
          type: 'error',
        })
      } finally {
        // Ensure modal is closed and state is reset
        this.showDeleteConfirmModal = false
        this.documentToDelete = null
        this.groupIndexToDelete = null
      }
    },
  },
}
</script>

<style scoped>
@import '@/styles/newJob.css';

/* Add these new rules at the top of the style section */
html,
body {
  overflow: hidden;
  height: 100%;
  margin: 0;
  padding: 0;
}

.viewDocumentFirstDiv {
  overflow-y: auto;
  background-color: white;
  padding-left: 22px !important;
  padding-right: 22px !important;
  padding-top: 18px !important;
  padding-bottom: 28px !important;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 110px);
  border-radius: 8px;
  position: relative;
}

.viewDocumentContainer {
  width: 100%;
  height: calc(100vh - 110px);
  border-radius: 8px;
  background: var(--secondary-color);
  /* padding: 0px; */
  display: flex;
  flex-direction: column;
  gap: 10px !important;
  overflow-y: hidden;
  /* background-color: red; */
  /* margin-top: -20px; */
}

.extractionConfidence {
  font-size: 9px;
  background-color: white;
  padding: 5px;
  position: relative;
  top: 13px;
  right: 10px;
  font-weight: 700;
}
.activeImg {
  border: 2px solid #28aef5 !important;
  /* padding: 5px; */
}

.input-container {
  width: 100%;
  /* margin-top: 20px; */
  /* display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: flex-start;
  align-items: center; */
  /* background-color: red; */
}
.input-containerBox {
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: space-between;
  align-items: flex-end;
  /* background-color: red; */
}
input[type='text'] {
  width: 399px;
  height: 37px;
  flex-shrink: 0;

  color: #5c656c;
  font-family: Archivo;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  border: 1px solid #ccc; /* Optional: Add border */
  border-radius: 4px; /* Optional: Round corners */
  padding: 5px 10px; /* Optional: Add padding */
  outline: none; /* Removes default focus outline */
  border-radius: 8px;
  background: #fff;
}
input[type='date'] {
  width: 399px;
  height: 37px;
  flex-shrink: 0;

  color: #5c656c;
  font-family: Archivo;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  border: 1px solid #ccc; /* Optional: Add border */
  border-radius: 4px; /* Optional: Round corners */
  padding: 5px 10px; /* Optional: Add padding */
  outline: none; /* Removes default focus outline */
  border-radius: 8px;
  background: #fff;
}
input[type='select'] {
  width: 399px;
  height: 37px;
}
.activeImgNew {
  color: #28aef5 !important;
  border: 2px solid #28aef5 !important; /* Optional: Add border */
}

.inputLabel {
  min-width: 150px;
  max-width: 200px;
  color: #8b8888;
  font-size: 16px;
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
  display: flex;
  align-items: center;
  height: auto;
  min-height: 17.474px;
  line-height: 1.2;
  color: #8b8888;
  font-family: Archivo;
  font-size: 18px;
  font-weight: 400;
}

.button-row {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 10px;
}
/* .viewDocumentLabel:not(:first-child) {
  margin-top: 50px;
} */

.pageHeaderViewDocumentTitle {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: white;

  /* padding: 10px 0; */
}
.pageHeaderViewDocument {
  /* background-color: white;
  position: sticky;
  top: 0;
  z-index: 900; */
  /* padding: 10px 0; */
}
.pdfViewerNew {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
}

.documentViewHeader {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px;
  /* background-color: red; */
  width: 100%;
  /* padding: 10px; */
}

.myCustomButton {
  position: relative;
  bottom: -10px;
  background-color: red;
}

.documentViewContainer {
  border-radius: 8px;
  background: #f7f8f8;
  width: 100%;
  height: 100%;
  flex-shrink: 0;
  /* margin-left: 23px; */
  padding: 10px;
  border-radius: 8px;
  background: #f7f8f8;
  max-height: calc(100vh - 110px);
  /* height: calc(100vh - 100px); */
  display: flex;
  flex-direction: column;
  overflow: hidden; /* Prevent content from overflowing */
  padding: 10px;
}

.documentViewHeader {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  min-height: 40px; /* Add minimum height */
  flex-shrink: 0; /* Prevent header from shrinking */
}

.pdfViewerNew {
  width: 100%;
  flex: 1; /* Take remaining space */
  min-height: 0; /* Allow container to shrink below content size */
  overflow-y: auto; /* Enable scrolling if content overflows */
  position: relative; /* Establish positioning context */
}

.pdfViewFooter {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-radius: 0 0 8px 8px;
  width: 100%;
  flex-shrink: 0;
  height: 50px;
  padding: 0 15px;
  position: sticky;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-top: 1px solid #e2e2e2;
}

/* Ensure ImageHighlighter component fits within container */
.pdfViewerNew :deep(.ImageHighlighter) {
  max-width: 100%;
  max-height: 100%;
  overflow: auto;
}

/* Document History Button Styles */
.document-history-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #6c757d !important;
  border: none;
  color: white;
  padding: 10px 16px;
  border-radius: 6px;
  font-family: Archivo, sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.document-history-btn:hover {
  background: #5a6268 !important;
  transform: translateY(-1px);
}

.document-history-btn svg {
  width: 16px;
  height: 16px;
}

/* Document History Header Button */
.document-history-header-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  background: var(--primary-color);
  border: none;
  color: white;
  padding: 6px 12px;
  border-radius: 4px;
  font-family: Archivo, sans-serif;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.document-history-header-btn:hover {
  background: #0f3a4f;
  transform: translateY(-1px);
}

.document-history-header-btn svg {
  width: 14px;
  height: 14px;
}

.viewDocumentLabel {
  width: 100%;
  height: 17.474px;
  flex-shrink: 0;
  color: #32393e;
  font-family: Archivo;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  position: relative;
}

.cross-button {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: var(--primary-color);
  color: white;
  font-size: 16px;
  cursor: pointer;
  margin-left: 10px;
  transition: all 0.2s ease;
  position: relative;
  top: -2px;
}

.cross-button:hover {
  background-color: #0d3549;
  transform: scale(1.1);
}

.score {
  float: right;
  font-weight: 400;
  font-size: 13px;
  display: inline-flex;
  align-items: center;
  gap: 0;
}

.delete-button {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  margin-left: 8px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.delete-button svg {
  stroke: #d32f2f;
  color: #d32f2f;
  width: 16px;
  height: 16px;
}

.delete-button:hover svg {
  stroke: #b71c1c;
  color: #b71c1c;
  transform: scale(1.1);
}
.documentViewHR {
  width: 100%;
  height: 1px;
  background: #e2e2e2;
  margin-top: 20px;
  margin-bottom: 28px;
}
.documentViewHRNew {
  width: 100%;
  height: 1px;
  background: #e2e2e2;
  margin-top: 5px;
  margin-bottom: 28px;
}

.categoryCollection {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap; /* Prevent wrapping to new line */
  width: 100%;
  gap: 16px;
  justify-content: space-between; /* Distribute space evenly */
  margin-top: -14px;
}

.categoryContainer {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 0px;
}

.categoryTitle {
  color: #8b8888;
  font-family: Archivo;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  white-space: nowrap; /* Prevent title from wrapping */
  overflow: hidden;
  text-overflow: ellipsis;
}

.categorySelect {
  width: 160px;
  /* max-width: 180px;
  min-width: 150px; */
  height: 37px;
  flex-shrink: 0;
  border-radius: 6px;
  border: 1px solid #dbdbdb;
  text-indent: 10px;
  color: #32393e;
  font-family: Archivo;
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
  background-color: white;
  cursor: pointer;
  appearance: auto;
  min-width: 0; /* Allow select to shrink */
  margin-top: -10px;
}

.categorySelect:disabled {
  /* background-color: #f5f5f5; */
  cursor: not-allowed;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: none;
}

.categorySelect option {
  color: #32393e;
  padding: 8px;
  background-color: white;
}

.categorySelect option:disabled {
  color: #8b8888;
}

.categorySelect option:checked {
  background-color: #f0f0f0;
  color: #32393e;
  font-weight: 500;
}

/* Style for the select when it has a value selected */
.categorySelect:not([value='']) {
  color: #32393e;
  font-weight: 500;
}

.pageCollection {
  display: flex;
  flex-direction: row;
  gap: 22px;
  margin-top: 20px;
  flex-wrap: wrap;
}
.pageContainerNew {
  width: 94.885px;
  height: 123.678px;
  flex-shrink: 0;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  background: #f1f1f1;
  /* overflow-y: auto; */
}
.pageImgDiv {
  height: 98px;
  display: flex;
  justify-content: center;
  align-items: center;
  /* background-color: red; */
}
.pageImgDivMain {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  /* background-color: red; */
}
.pageImg {
  width: 67px;
  height: 85px;
  flex-shrink: 0;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  background: lightgray -14.409px -10.975px / 143.011% 125.824% no-repeat;
  box-shadow: 4px -1px 6.9px 0px rgba(0, 0, 0, 0.1);
}
.pageDivContent {
  width: 94.885px;
  height: 24.866px;
  flex-shrink: 0;
  border-radius: 0px 0px 4px 4px;
  border: 1px solid #d9d9d9;
  background: #f6f6f6;
}
.pageDivContentActive {
  width: 90.885px !important;
  height: 21.866px;
}
.pageDivContentTexts {
  color: var(--primary-color);
  font-family: Archivo;
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 200% */
  padding: 2px 12px;
}
.pageDivContentTextsActive {
  padding: 2px 12px;
  /* display: flex;
  justify-content: center;
  align-items: center; */
}

.documentViewRightSideHeader {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  padding-right: 20px;
}
.newDocumentTitle {
  color: var(--Gray-700, #344054);
  font-family: Archivo;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
}
.text-red {
  color: red !important;
  font-weight: bold !important;
}
.text-black {
  color: black !important;
  font-weight: bold !important;
}
.text-green {
  color: #28a745 !important;
  font-weight: bold !important;
}
.text-yellow {
  color: #ffc107 !important;
  font-weight: bold !important;
}
.text-black {
  color: black !important;
  font-weight: bold !important;
}

.input-field-container {
  display: flex;
  flex-direction: column;
  gap: 2px;
  justify-content: flex-end;
  align-items: flex-end;
  width: 100%;
}

.dynamic-input {
  width: 100%;
  height: 37px;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid #ccc;
  font-size: 16px;
  color: #5c656c;
}

.inputLabel {
  min-width: 150px;
  color: #8b8888;
  font-size: 16px;
}

.input-containerBox {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 8px;
}
.splitTitleContainer {
  margin-top: 24px;
}
.splitTitle {
  color: var(--primary-color);
  font-family: Archivo;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}
.upload-button-new {
  width: 194px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 4px;
  background: var(--primary-color);
  color: #fff;
  font-family: Archivo;
  font-size: 17px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.refresh-button {
  width: 50px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 4px;
  background: var(--primary-color);
  font-family: Archivo;
  font-size: 17px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  cursor: pointer;
  border: none;
  transition: all 0.3s ease;

  &:active {
    transform: scale(0.95);
    background: #0f3444;
  }
}
.buttons-new {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}
.buttons-new-inner {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.pageNavigation {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  flex: 1;
}

.pageInfo {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #344054;
  font-family: Archivo;
  font-size: 14px;
}

.pageNumbers {
  background: white;
  padding: 4px 8px;
  border-radius: 4px;
  color: #344054;
  display: flex;
  width: 52px;
  height: 35px;
  padding: 8px 14px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.expandButton {
  cursor: pointer;
  padding: 5px;
  border-radius: 4px;
  transition: background-color 0.2s;
  display: flex;
  width: 43px;
  height: 43px;
  padding: 10px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 99px;
  background: var(--primary-color);
}

.expandButton:hover {
  background: var(--primary-color);
}
.pageInfoText {
  color: var(--Gray-700, #344054);
  font-family: Archivo;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
}

.workflow-button {
  padding: 10px 20px;
  background: var(--primary-color);
  color: white;
  border: none;
  border-radius: 6px;
  font-family: Archivo;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.workflow-button:hover {
  background: #0d2d3a;
}

.main-buttons {
  position: sticky;
  bottom: -35px;
  background-color: white;
  padding: 20px;
  margin-top: auto;
  width: 100%;
  z-index: 1000;
  border-radius: 8px;
  padding-top: 25px;

  /* box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1); */
}

.upload-button {
  width: 174px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 4px;
  background: var(--primary-color);
  color: #fff;
  font-family: Archivo;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  cursor: pointer;
  border: none;
  transition: all 0.3s ease;
}

.upload-button:disabled {
  background: #cccccc;
  color: #666666;
  cursor: not-allowed;
  opacity: 0.7;
}

.upload-button:not(:disabled):hover {
  background: #0d3549;
}

.no-x-scroll {
  overflow-x: hidden; /* disables horizontal scroll */
  width: 100%; /* ensure it doesn't exceed parent width */
  max-width: 100%; /* prevents children from stretching it */
  box-sizing: border-box; /* includes padding in width */
  white-space: normal; /* allows wrapping instead of horizontal scroll */
}

.no-data-message {
  text-align: center;
  padding: 20px;
  color: #666;
  font-size: 16px;
  font-family: Archivo;
  margin: 20px 0;
}
.headerContent {
  background-color: var(--secondary-color);
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 64px;
  /* padding: 24px 24px 24px 0x; */
  /* padding-bottom: 12px; */
  /* padding-top: 12px; */
  position: relative;
  gap: 12px;
  flex-wrap: nowrap;
  overflow-x: auto;
  min-width: 0;
  margin-bottom: 10px;
}

.mainPageTitle {
  display: flex;
  align-items: center;
  color: var(--primary-color);
  font-family: Archivo;
  font-size: 22px;
  font-weight: 600;
  line-height: 91.5%;
  cursor: pointer;
  min-width: 0;
}

.headerRightText {
  color: var(--primary-color);
  text-align: left;
  font-family: Archivo;
  font-size: 20px;
  font-weight: 600;
  line-height: 91.5%;
  min-width: 0;
}

.headerStatus {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-direction: row;
  min-width: 0;
}

.statusItem {
  display: flex;
  flex-direction: row;
  align-items: center;
  background: linear-gradient(145deg, #ffffff, #f0f0f0);
  padding: 4px 8px;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(22, 72, 99, 0.08);
  transition: all 0.3s ease;
  min-width: 120px;
  min-height: 32px;
  gap: 6px;
  flex-shrink: 1;
  max-width: 220px;
  overflow: hidden;
}

.statusItem:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.12);
}

.statusIcon {
  color: var(--primary-color);
  background: rgba(22, 72, 99, 0.08);
  padding: 7px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0;
}

.statusLabel {
  color: var(--primary-color);
  font-family: Archivo;
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 0;
  opacity: 0.92;
  margin-right: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.statusValue {
  color: var(--primary-color);
  font-family: Archivo;
  font-size: 15px;
  font-weight: 700;
  background: none;
  -webkit-background-clip: unset;
  -webkit-text-fill-color: unset;
  padding: 0 2px;
  white-space: nowrap;
}

.headerDocumentDropdown {
  height: 39px;
  display: flex;
  align-items: center;
  min-width: 0;
  flex-shrink: 1;
  width: 280px !important;
  /* width: 220px !important; */
}

/* .documentDropdown {
  height: 32px;
  width: 220px !important;
  font-size: 12px;
  min-width: 90px;
  max-width: 130px;
  padding: 0 8px;
  display: flex;
  align-items: center;
  flex-shrink: 1;
} */

.documentDropdown,
.pageDropdown {
  padding: 4px 10px;
  border-radius: 6px;
  border: 1px solid var(--primary-color);
  font-family: Archivo;
  font-size: 13px;
  color: var(--primary-color);
  background: #f7fafd;
  min-width: 120px;
  outline: none;
  transition: border 0.2s;
  box-shadow: 0 1px 2px rgba(22, 72, 99, 0.04);
}
.documentDropdown:focus,
.pageDropdown:focus {
  border: 1.5px solid #28aef5;
}

/* New styles for document classification cards */
.doc-classification-card {
  background: #ffffff;
  border-radius: 12px;
  padding: 10px;
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08); */
  /* transition: all 0.3s ease; */
  border: 1px solid #e2e2e2;
  /* position: relative; */
  /* overflow: hidden; */
  overflow-y: auto;
}

.doc-classification-card:first-child {
  margin-top: 2px;
}

.doc-classification-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: var(--primary-color);
  opacity: 0;
  /* transition: opacity 0.3s ease; */
}

.doc-classification-card-active {
  border-color: var(--primary-color);
  box-shadow: 0 4px 12px rgba(22, 72, 99, 0.15);
  transform: translateY(-2px);
}

.doc-classification-card-active::before {
  opacity: 1;
}

.doc-classification-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  transform: translateY(-2px);
}

.doc-classification-card .pageHeaderViewDocument {
  background: transparent;
  padding: 0;
  margin-bottom: 16px;
}

.doc-classification-card .categoryCollection {
  background: #f8f9fa;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 16px;
}

.doc-classification-card .pageCollection {
  background: #ffffff;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #e2e2e2;
}

.doc-classification-card-active .categoryCollection {
  /* background: #f0f7ff; */
}

.doc-classification-card-active .pageCollection {
  border-color: var(--primary-color);
}

.document-serial-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: var(--primary-color);
  color: white;
  border-radius: 50%;
  font-size: 14px;
  font-weight: 600;
  margin-right: 12px;
  font-family: Archivo;
  flex-shrink: 0;
}

.document-change-indicator {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  color: #ff9800;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}

.doc-card-checkbox {
  position: relative;
  display: inline-block;
  margin-right: 12px;
  /* margin-top: 12px; */
  cursor: pointer;
  user-select: none;
}

.doc-card-checkbox input {
  /* position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0; */
}

.checkmark {
  position: relative;
  display: inline-block;
  height: 18px;
  top: 3px;
  width: 18px;
  background-color: #fff;
  border: 2px solid var(--primary-color);
  border-radius: 4px;
  transition: all 0.2s ease;
}
.checkmarkNew {
  position: relative;
  display: inline-block;
  height: 18px;
  top: 3px;
  width: 18px;
  background-color: #fff;
  border: 2px solid var(--primary-color);
  border-radius: 4px;
  transition: all 0.2s ease;
}

.doc-card-checkbox input:checked ~ .checkmark {
  background-color: var(--primary-color);
}

.checkmark:after {
  content: '';
  position: absolute;
  display: none;
  left: 5px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.doc-card-checkbox input:checked ~ .checkmark:after {
  display: block;
}

.doc-card-header-actions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 8px;
}

.select-all-changed-btn {
  background: var(--primary-color);
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 13px;
  font-family: Archivo;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.select-all-changed-btn:hover {
  background: #0d3549;
}

.doc-selection-header {
  display: flex;
  justify-content: flex-end;
  padding: 0px 0;
  margin-bottom: 10px;
  background-color: white;
  border-radius: 8px;
  margin-top: -2px;
}

.select-all-changed-btn {
  background: var(--primary-color);
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  font-family: Archivo;
  cursor: pointer;
  transition: background-color 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.select-all-changed-btn:hover {
  background: #0d3549;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-content {
  text-align: center;
  background: white;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  width: 300px;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid var(--primary-color);
  border-radius: 50%;
  margin: 0 auto 20px;
  animation: spin 1s linear infinite;
}

.loading-text {
  color: var(--primary-color);
  font-family: Archivo;
  font-size: 16px;
  margin-bottom: 20px;
}

.progress-container {
  width: 100%;
  height: 20px;
  background: #f3f3f3;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
}

.progress-bar {
  height: 100%;
  background: var(--primary-color);
  transition: width 0.3s ease;
}

.progress-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 12px;
  font-weight: bold;
  text-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Update upload button styles for progress state */
.upload-button {
  position: relative;
  overflow: hidden;
}

.upload-button:disabled {
  background: var(--primary-color);
  opacity: 0.8;
  cursor: not-allowed;
}

.extraction-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}

.modified-indicator {
  display: flex;
  align-items: center;
  color: var(--primary-color);
  animation: fadeIn 0.3s ease-in-out;
}

.modified-indicator svg {
  width: 16px;
  height: 16px;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.field-number {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: var(--primary-color);
  color: white;
  border-radius: 50%;
  font-size: 14px;
  font-weight: 600;
  margin-right: 12px;
  font-family: Archivo;
  flex-shrink: 0;
  margin-top: 2px;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.select-all-checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.checkbox-label {
  color: #344054;
  font-size: 14px;
  font-weight: 500;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.spinning {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.zoom-controls {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-right: 20px;
}

.zoom-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  background: var(--primary-color);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
  color: white;
}

.zoom-button:hover {
  background: #0f3444;
  transform: scale(1.05);
}

.zoom-button:active {
  transform: scale(0.95);
}

.zoom-button svg {
  width: 16px;
  height: 16px;
}

.vasion-status-indicator {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-left: 10px;
  transition: all 0.2s ease;
  position: relative;
  top: -2px;
}

.vasion-status-indicator.vasion-status-completed {
  background-color: #28a745;
  border: 2px solid #28a745;
}

.vasion-status-indicator.vasion-status-pending {
  background-color: #ffc107;
  border: 2px solid #ffc107;
}

.vasion-status-indicator.vasion-status-partial {
  background-color: #ffc107;
  border: 2px solid #ffc107;
}

.vasion-status-indicator:hover {
  transform: scale(1.1);
}

.document-name-truncated {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.vasion-status-text {
  margin-left: 5px;
  font-size: 12px;
  font-weight: 500;
  color: #8b8888;
}

.vasion-status-display {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  /* background: rgba(255, 255, 255, 0.9); */
  padding: 6px 10px;
  border-radius: 6px;
  /* border: 1px solid #e2e2e2; */
  /* box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1); */
  /* transition: all 0.2s ease; */
  /* cursor: default; */
  /* margin-top: 10px; */
}

.vasion-status-display:hover {
  /* box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15); */
  /* transform: translateY(-1px); */
}

.vasion-status-label {
  margin-right: 8px;
  font-weight: 600;
  font-size: 13px;
  color: #5c656c;
}

.vasion-status-value {
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 13px;
  padding: 2px 6px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.vasion-status-value.vasion-status-completed {
  color: #28a745;
  background: rgba(40, 167, 69, 0.1);
  border: 1px solid rgba(40, 167, 69, 0.2);
}

.vasion-status-value.vasion-status-pending {
  color: #ffc107;
  background: rgba(255, 193, 7, 0.1);
  border: 1px solid rgba(255, 193, 7, 0.2);
}

.vasion-status-icon {
  width: 12px;
  height: 12px;
  margin-right: 5px;
  flex-shrink: 0;
}

.vasion-status-value.vasion-status-completed .vasion-status-icon {
  color: #28a745;
}

.vasion-status-value.vasion-status-pending .vasion-status-icon {
  color: #ffc107;
}

/* Split Button for Vasion - new styles */
.split-btn-vasion-group {
  display: inline-flex;
  position: relative;
  vertical-align: middle;
}
.split-btn-vasion-main {
  background: var(--primary-color);
  color: #fff;
  border: none;
  border-radius: 4px 0 0 4px;
  padding: 8px 18px;
  font-size: 14px;
  cursor: pointer;
  outline: none;
  transition: background 0.2s;
}
.split-btn-vasion-main:disabled {
  background: #cccccc;
  color: #666666;
  cursor: not-allowed;
}
.split-btn-vasion-toggle {
  background: var(--primary-color);
  color: #fff;
  border: none;
  border-radius: 0 4px 4px 0;
  padding: 8px 12px;
  font-size: 14px;
  cursor: pointer;
  outline: none;
  transition: background 0.2s;
}
.split-btn-vasion-toggle:disabled {
  background: #cccccc;
  color: #666666;
  cursor: not-allowed;
}
.split-btn-dropup {
  position: absolute;
  bottom: 100%;
  left: 0;
  min-width: 180px;
  background: #fff;
  border: none;
  border-radius: 6px 6px 6px 6px;
  box-shadow: 0 2px 8px rgba(60, 64, 67, 0.15);
  z-index: 9999;
  list-style: none;
  margin: 0;
  padding: 4px 0;
  transition: background 0.2s;
}

.split-btn-dropup li {
  padding: 12px 20px;
  cursor: pointer;
  font-size: 15px;
  color: #444;
  background: transparent;
  border: none;
  border-radius: 0;
  margin: 0;
  transition: background 0.18s, color 0.18s;
}

.split-btn-dropup li:hover {
  background: #f5f5f5;
  color: #222;
}
.document-nav-buttons {
  margin-right: 20px;
  display: flex;
  justify-content: center;
}
.document-nav-btn {
  height: 38px;
  padding: 0 16px;
  background: var(--primary-color);
  color: #fff;
  border: none;
  border-radius: 4px;
  font-family: Archivo;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
}
.document-nav-btn:disabled {
  background: #cccccc;
  color: #666666;
  cursor: not-allowed;
  opacity: 0.7;
}

.document-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 10px;
}

/* Add this to the <style> section, scoped if needed */
.zoom-button.active {
  background-color: #e0f7fa; /* Light blue background */
  border: 2px solid #00bcd4; /* Cyan border */
  box-shadow: 0 0 8px #00bcd4;
  color: #00bcd4; /* Change icon color if using currentColor */
  transition: all 0.2s;
}
.zoom-button.active svg {
  stroke: #00bcd4; /* Ensures the SVG icon color changes */
}

/* Vasion Status Selection and Send Button */
.vasion-status-action-group {
  display: flex;
  align-items: center;
  gap: 0;
  /* margin-top: 10px; */
}

.vasion-status-dropdown {
  width: 130px;
  height: 40px;
  border: 1px solid var(--primary-color, #164863);
  border-right: none;
  border-radius: 6px 0 0 6px;
  text-indent: 10px;
  color: #32393e;
  font-family: Archivo;
  font-size: 15px;
  font-weight: 400;
  line-height: normal;
  background-color: white;
  cursor: pointer;
  appearance: auto;
  min-width: 0;
  margin-top: 0;
  box-sizing: border-box;
}

.vasion-status-dropdown:disabled {
  cursor: not-allowed;
  background-color: #f5f5f5;
}

.vasion-send-btn {
  width: 120px;
  height: 40px;
  border: 1px solid var(--primary-color, #164863);
  border-left: none;
  border-radius: 0 6px 6px 0;
  background: var(--primary-color, #164863);
  color: #fff;
  font-family: Archivo;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  cursor: pointer;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.vasion-send-btn:disabled {
  background: #cccccc;
  color: #666666;
  cursor: not-allowed;
  opacity: 0.7;
}

.vasion-send-btn:not(:disabled):hover {
  background: #0d3549;
}

/* Summary Generation Indicator Styles */
.summary-generating-inline {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  color: var(--primary-color, #164863);
  margin-bottom: 0;
  padding-top: 2px;
  line-height: 1;
}

.generating-dot {
  width: 4px;
  height: 4px;
  background-color: var(--primary-color, #164863);
  border-radius: 50%;
  animation: dotBounce 1.2s infinite;
  display: inline-block;
  flex-shrink: 0;
  vertical-align: middle;
}

.generating-dot:nth-child(1) {
  animation-delay: 0s;
}

.generating-dot:nth-child(2) {
  animation-delay: 0.2s;
}

.generating-dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes dotBounce {
  0%, 100% {
    opacity: 0.4;
  }
  50% {
    opacity: 1;
  }
}

.summary-text-small {
  font-weight: 500;
  vertical-align: middle;
  line-height: 1;
}

</style>
